import React from "react";
import { BaseDistributorLogoProps } from "./DistributorLogo";
import DistributorLogoThemes from "./DistributorLogoThemes";

export default function CovetrusLogo({
  className,
  width = 98,
  height = 22,
  theme,
}: BaseDistributorLogoProps): React.JSX.Element {
  if (theme === DistributorLogoThemes.Icon) {
    return (
      <span className="text-xs text-error">
        Distributor logo theme '{theme}' not supported
      </span>
    );
  }

  if (theme === DistributorLogoThemes.Light) {
    return (
      <svg
        className={className}
        width={width}
        height={height}
        viewBox="0 0 3248 722"
        version="1.1"
        id="Layer_1"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        x="0px"
        y="0px"
      >
        <path
          fill="none"
          opacity="1.000000"
          stroke="none"
          d="
            M2377.000000,660.000000 
              C1584.666626,660.000000 792.833313,660.000000 1.000000,660.000000 
              C1.000000,440.333344 1.000000,220.666672 1.000000,1.000000 
              C1063.333374,1.000000 2125.666748,1.000000 3188.000000,1.000000 
              C3188.000000,220.666672 3188.000000,440.333344 3188.000000,660.000000 
              C2917.833252,660.000000 2647.666748,660.000000 2377.000000,660.000000 
            M2782.021484,274.529114 
              C2791.825195,280.037750 2801.605957,285.587158 2811.437988,291.044922 
              C2824.788818,298.456207 2838.462646,305.340851 2851.404541,313.404144 
              C2856.250977,316.423737 2859.823975,315.814423 2863.837158,313.588196 
              C2876.602539,306.506653 2889.231445,299.179657 2901.952148,292.016418 
              C2911.312744,286.745300 2920.776855,281.656921 2930.117432,276.351196 
              C2940.739502,270.317474 2951.220947,264.035492 2961.864990,258.041626 
              C2971.757324,252.470932 2981.863281,247.277237 2991.727295,241.658600 
              C3001.063965,236.340561 3010.110840,230.513138 3019.463867,225.225586 
              C3030.044434,219.244125 3040.905518,213.759918 3051.498535,207.800186 
              C3070.267334,197.241043 3088.941406,186.513214 3107.597656,175.756241 
              C3108.968018,174.966019 3110.919434,173.199478 3110.752441,172.193130 
              C3110.502686,170.686081 3108.857422,169.029816 3107.379150,168.172882 
              C3101.035889,164.496048 3094.490479,161.170807 3088.103516,157.567139 
              C3071.170166,148.013199 3054.315918,138.318497 3037.358398,128.807999 
              C3029.555176,124.431656 3021.470947,120.551811 3013.718994,116.090782 
              C3004.798828,110.957657 2996.231689,105.208542 2987.281738,100.130730 
              C2975.986816,93.722397 2964.384521,87.857880 2953.052002,81.513603 
              C2936.790039,72.409760 2920.634277,63.115551 2904.466797,53.844257 
              C2890.939697,46.087265 2877.401367,38.346603 2863.993408,30.387745 
              C2859.450195,27.690945 2855.459229,27.676798 2850.957275,30.439516 
              C2842.760986,35.469276 2834.413330,40.260147 2826.029541,44.974724 
              C2811.462402,53.166504 2796.776367,61.147388 2782.219727,69.357635 
              C2763.044678,80.172791 2743.974365,91.173645 2724.804199,101.997375 
              C2714.219238,107.973640 2703.440430,113.608147 2692.895020,119.651352 
              C2676.740479,128.909042 2660.755615,138.462204 2644.615479,147.744827 
              C2633.355713,154.220642 2621.938965,160.423279 2610.633057,166.819473 
              C2608.184570,168.204712 2605.909424,169.896027 2603.554199,171.446320 
              C2603.505127,172.058182 2603.456055,172.670029 2603.406982,173.281891 
              C2608.972412,176.387192 2614.567627,179.440552 2620.097412,182.607727 
              C2635.414062,191.379791 2650.632080,200.325699 2666.025391,208.960556 
              C2678.618652,216.024780 2691.481689,222.608200 2704.083740,229.656876 
              C2712.496826,234.362320 2720.581787,239.650909 2728.955322,244.430435 
              C2746.399170,254.387039 2763.936768,264.178986 2782.021484,274.529114 
            M2979.004395,560.494568 
              C2990.906738,553.901062 3002.846436,547.374146 3014.702393,540.698669 
              C3032.771484,530.525146 3050.776611,520.238708 3068.819824,510.019623 
              C3081.795410,502.670593 3094.839355,495.440613 3107.748047,487.976196 
              C3112.477539,485.241364 3112.303711,483.622742 3107.576660,480.948395 
              C3099.039551,476.118683 3090.488525,471.313934 3081.962891,466.463989 
              C3063.530029,455.978088 3045.132568,445.429199 3026.675537,434.986053 
              C3014.502197,428.098083 3002.220703,421.401764 2990.040283,414.525909 
              C2973.831543,405.376129 2957.690674,396.106232 2941.489258,386.943237 
              C2929.336670,380.070160 2917.108154,373.331116 2904.961426,366.447571 
              C2890.720459,358.377411 2876.643311,350.006958 2862.215576,342.289001 
              C2859.682861,340.934174 2855.391602,341.214935 2852.585449,342.372284 
              C2846.984863,344.681793 2841.827393,348.081451 2836.529541,351.105499 
              C2824.684814,357.866821 2812.852783,364.650696 2801.040771,371.468933 
              C2788.090332,378.944214 2775.235596,386.588440 2762.214355,393.937500 
              C2749.224854,401.268616 2736.030762,408.236755 2723.024170,415.537842 
              C2716.016113,419.471619 2709.319092,423.961182 2702.292480,427.859375 
              C2691.098389,434.069641 2679.713135,439.933563 2668.471924,446.060150 
              C2658.789307,451.337402 2649.160889,456.716736 2639.570557,462.160461 
              C2628.412354,468.494110 2617.261475,474.845886 2606.236572,481.407318 
              C2602.774414,483.467621 2603.198242,485.808502 2607.065674,487.997406 
              C2621.882812,496.384460 2636.714111,504.746735 2651.544434,513.110840 
              C2662.723145,519.415466 2673.895020,525.732910 2685.093506,532.002380 
              C2713.109131,547.686768 2741.143799,563.337769 2769.160156,579.020630 
              C2785.239502,588.021484 2801.343750,596.979614 2817.353271,606.103821 
              C2830.713135,613.717834 2843.951416,621.545471 2857.197754,629.251953 
              C2897.840820,606.354004 2938.123535,583.658936 2979.004395,560.494568 
            M1069.999756,439.499786 
              C1077.195068,445.695953 1084.124146,452.239014 1091.643921,458.012604 
              C1105.293579,468.492767 1121.263184,474.166260 1137.515381,479.231720 
              C1148.771240,482.739899 1160.371460,484.384521 1171.965576,484.821747 
              C1196.685059,485.754028 1221.105591,484.666992 1245.164795,476.773682 
              C1263.454224,470.773346 1279.780151,461.835968 1294.214722,449.820648 
              C1306.137207,439.896362 1317.120117,428.581512 1325.412842,414.303040 
              C1323.264526,412.697754 1321.304077,410.891663 1319.047363,409.605530 
              C1309.341675,404.074554 1299.436401,398.886658 1289.821777,393.205170 
              C1281.395264,388.225769 1273.356445,382.588287 1264.906006,377.653107 
              C1263.372314,376.757324 1260.092163,377.085022 1258.654175,378.192688 
              C1256.310059,379.998352 1254.880005,382.960449 1252.958130,385.349335 
              C1242.564819,398.268616 1229.951294,407.991364 1213.552124,411.937958 
              C1209.006714,413.031830 1204.283691,413.794708 1199.621704,413.914856 
              C1188.795044,414.193939 1177.704956,415.452881 1167.178955,413.647766 
              C1149.936035,410.690765 1134.667358,402.628387 1122.825073,389.254059 
              C1115.090698,380.519012 1108.368530,371.114868 1106.301514,358.000000 
              C1134.062256,358.000000 1161.640747,358.000000 1189.219116,358.000000 
              C1236.880493,358.000000 1284.541870,358.000000 1332.203247,357.999939 
              C1333.369751,357.999939 1334.755371,358.397186 1335.650879,357.904419 
              C1336.952271,357.188354 1338.863647,355.823120 1338.855835,354.746796 
              C1338.715576,335.328583 1339.405518,315.814941 1337.667847,296.524353 
              C1336.106445,279.190704 1329.237061,262.817200 1320.697876,247.762146 
              C1309.595215,228.187195 1294.714722,211.764801 1275.747437,198.952866 
              C1262.134766,189.757874 1247.661377,182.910080 1231.999268,178.662186 
              C1223.297363,176.302094 1214.080200,175.904953 1205.266113,173.880127 
              C1193.015625,171.065964 1180.826172,171.663666 1168.532837,172.978104 
              C1155.509155,174.370605 1142.922852,177.153061 1130.503540,181.609421 
              C1111.891357,188.287933 1094.751709,197.349411 1080.140625,210.556244 
              C1068.326416,221.234985 1057.586670,232.877487 1049.343384,246.895905 
              C1036.179565,269.281982 1028.731079,293.083344 1028.037476,318.987152 
              C1027.801147,327.813171 1027.613403,336.673035 1028.118774,345.476410 
              C1028.545532,352.910065 1029.734619,360.333649 1031.064697,367.675018 
              C1034.219482,385.086060 1041.577637,400.981659 1050.697144,415.865387 
              C1055.843140,424.263947 1063.160278,431.332184 1069.999756,439.499786 
            M621.685242,475.036682 
              C622.017944,475.021790 622.381897,475.090637 622.678955,474.979980 
              C637.087341,469.613434 650.275146,462.138153 662.669495,452.994507 
              C674.853821,444.005707 685.013000,433.045898 693.812500,421.027557 
              C703.166199,408.252441 710.171387,394.108398 715.245117,378.869965 
              C720.023926,364.517212 722.395630,349.909454 722.814270,335.025116 
              C723.108765,324.553772 722.002197,313.998657 720.912903,303.544342 
              C719.641724,291.344360 716.642639,279.453186 711.607605,268.240326 
              C704.080566,251.477692 695.206604,235.417618 681.843994,222.539963 
              C673.400330,214.402786 664.316223,206.860870 655.033020,199.680908 
              C641.949097,189.561432 626.649109,183.797287 610.987610,178.977493 
              C599.783691,175.529526 588.239868,174.270035 576.646973,172.721909 
              C560.683716,170.590103 545.073853,172.662140 529.759277,175.508759 
              C517.354797,177.814484 505.382965,183.074661 493.602600,187.950684 
              C479.491241,193.791550 467.062683,202.603561 455.750824,212.825729 
              C443.205231,224.162720 433.535736,237.715668 424.813477,252.216949 
              C413.560028,270.926300 408.364990,291.375702 406.279633,312.568787 
              C405.072968,324.832336 406.147797,337.412201 407.126801,349.775970 
              C408.377228,365.567139 412.130707,380.817963 419.948578,394.851257 
              C424.145966,402.385742 427.712769,410.296387 432.252197,417.610168 
              C441.138336,431.927185 453.707855,443.024536 466.468201,453.625122 
              C480.412384,465.209106 496.908752,472.424622 514.095703,478.065704 
              C524.793945,481.576996 535.608398,484.121460 546.942810,484.038177 
              C561.433838,483.931702 576.026367,484.908905 590.382751,483.482605 
              C600.753845,482.452271 610.811401,478.265778 621.685242,475.036682 
            M1942.000000,239.500000 
              C1942.000000,221.501923 1942.000366,203.503860 1941.999756,185.505783 
              C1941.999390,178.000366 1941.998413,178.000092 1934.837402,178.000046 
              C1912.672852,177.999908 1890.508301,177.999969 1868.343750,178.000031 
              C1861.003174,178.000061 1861.000488,178.000168 1861.000366,185.324646 
              C1860.999634,241.319336 1860.820312,297.315033 1861.136108,353.307953 
              C1861.207886,366.050812 1862.996216,378.783844 1863.990234,391.521729 
              C1865.326660,408.646515 1872.151001,423.827911 1881.088501,438.095490 
              C1887.971924,449.083923 1896.498291,458.517975 1907.764526,465.572784 
              C1914.326050,469.681610 1920.631226,473.904480 1928.145996,476.029541 
              C1937.367065,478.637115 1946.412598,482.371643 1955.806885,483.725708 
              C1966.385498,485.250397 1977.331909,485.530151 1987.999512,484.742615 
              C1997.528931,484.039032 2007.169067,481.982849 2016.272217,479.022705 
              C2030.293823,474.463165 2042.591187,466.632660 2052.824463,455.764160 
              C2055.329834,453.103424 2058.406006,450.980072 2061.786865,448.131714 
              C2062.345947,459.037811 2062.850342,468.877319 2063.356201,478.749695 
              C2089.234375,478.749695 2114.971436,478.749695 2140.755371,478.749695 
              C2140.755371,378.434143 2140.755371,278.369141 2140.755371,178.000000 
              C2121.214111,178.000000 2101.916260,177.999969 2082.618408,178.000015 
              C2077.285645,178.000031 2071.919189,177.648560 2066.634277,178.151199 
              C2064.054199,178.396576 2060.050781,177.683136 2059.958252,182.603317 
              C2059.761719,193.024094 2059.068359,203.439941 2059.045410,213.858841 
              C2058.941406,261.020813 2058.992676,308.183105 2059.005615,355.345306 
              C2059.008545,366.627747 2055.935791,376.976654 2049.883057,386.488739 
              C2043.235474,396.936371 2034.317139,405.055237 2023.037720,409.831970 
              C2012.395508,414.338867 2000.752075,413.759796 1989.532715,412.563934 
              C1983.348755,411.904755 1977.178589,409.375427 1971.428345,406.754181 
              C1960.001831,401.545258 1952.725342,392.195099 1948.357422,380.662292 
              C1946.155273,374.847870 1943.411865,368.768494 1943.229980,362.739075 
              C1942.378784,334.504822 1942.289429,306.246735 1942.020142,277.996277 
              C1941.901001,265.498596 1942.000000,252.998825 1942.000000,239.500000 
            M2447.027588,229.543930 
              C2436.953369,215.989838 2425.035400,204.288086 2411.136230,194.725540 
              C2402.118652,188.521408 2392.195068,184.310913 2381.771240,180.624802 
              C2366.246582,175.134933 2350.612793,171.935593 2334.224365,171.993607 
              C2324.391602,172.028427 2314.545898,171.697601 2304.730469,172.108856 
              C2298.436768,172.372528 2292.051514,173.143829 2285.949951,174.661926 
              C2277.118408,176.859314 2268.129639,179.112000 2259.901367,182.862610 
              C2250.772217,187.023727 2242.009277,192.315308 2233.827148,198.152557 
              C2219.895264,208.091614 2210.153564,221.301178 2203.610840,237.407806 
              C2198.627441,249.675507 2199.414551,262.037109 2198.876953,274.579193 
              C2198.515869,282.997803 2200.958008,290.774170 2203.891602,298.144684 
              C2211.755371,317.902893 2227.248535,330.388184 2246.134766,338.963593 
              C2252.077393,341.661835 2258.332275,343.685028 2264.484863,345.904205 
              C2270.331787,348.013153 2276.107910,350.517853 2282.133301,351.892853 
              C2296.734619,355.224976 2311.579834,357.532684 2326.103760,361.148956 
              C2337.716064,364.040314 2349.500000,367.160004 2360.319336,372.117065 
              C2379.181641,380.759277 2375.687500,397.816650 2362.049072,409.422852 
              C2352.853027,417.248383 2341.311279,418.110657 2330.099854,418.790649 
              C2322.839111,419.230988 2315.318848,418.302521 2308.168945,416.788116 
              C2301.838867,415.447357 2295.149170,413.507660 2289.871582,409.965118 
              C2278.436523,402.289429 2268.375244,392.896301 2261.886230,378.672913 
              C2236.024170,386.761658 2211.675781,398.612061 2185.474121,407.368652 
              C2186.176270,410.078003 2186.378418,412.747498 2187.512207,414.933990 
              C2196.731934,432.715668 2208.976562,447.944031 2226.191895,458.594940 
              C2234.461426,463.710968 2243.038574,468.356323 2251.665771,472.851318 
              C2254.440430,474.297058 2258.009277,474.162933 2260.892090,475.465851 
              C2275.489502,482.063232 2291.164062,483.895447 2306.754395,484.749542 
              C2321.775879,485.572479 2336.912842,484.410645 2351.993164,483.937988 
              C2355.377930,483.831848 2358.829590,483.293030 2362.093262,482.387024 
              C2371.180176,479.864319 2380.354980,477.506561 2389.188232,474.250885 
              C2412.095703,465.807678 2429.752686,450.878937 2442.532471,430.023682 
              C2450.945557,416.294128 2455.601318,401.633026 2454.976074,385.459259 
              C2454.798584,380.870544 2454.242432,376.297394 2454.019287,371.709381 
              C2453.494873,360.924408 2449.415771,351.334747 2443.811523,342.397980 
              C2433.683105,326.246216 2418.488281,315.745728 2401.514893,308.539368 
              C2387.740234,302.691132 2373.032715,298.765594 2358.447998,295.166290 
              C2338.185059,290.165710 2317.343262,287.439606 2297.733643,279.913910 
              C2293.020996,278.105255 2288.071777,275.873230 2284.446289,272.521606 
              C2279.401611,267.858032 2280.280029,261.093292 2281.649170,254.992538 
              C2282.355225,251.846909 2283.612549,247.805176 2285.986572,246.240158 
              C2293.892822,241.028107 2302.038818,235.963486 2312.373779,236.901947 
              C2318.324463,237.442307 2324.376465,237.242493 2330.361572,236.947144 
              C2341.245361,236.410095 2350.940918,240.203445 2359.361816,246.249222 
              C2365.640137,250.756790 2370.624512,257.127563 2375.924316,262.907715 
              C2378.019043,265.192230 2379.127930,268.446472 2383.223145,266.027191 
              C2385.811035,264.498291 2388.632324,263.320923 2391.437256,262.208893 
              C2408.966553,255.258987 2426.546143,248.435257 2444.055664,241.435699 
              C2452.212891,238.174759 2452.158447,238.038406 2447.027588,229.543930 
            M338.512207,448.993500 
              C340.635773,447.202698 342.968628,445.606140 344.844299,443.585266 
              C350.884918,437.076843 357.381592,430.861511 362.538177,423.695374 
              C369.189484,414.451965 375.065552,404.593079 380.595306,394.622009 
              C383.857697,388.739380 382.250763,386.399780 375.657928,383.985016 
              C370.099915,381.949280 364.575806,379.810547 359.099060,377.565186 
              C344.137024,371.431091 329.220734,365.185364 314.256653,359.056366 
              C310.636963,357.573761 308.101074,358.529205 306.157745,362.307251 
              C298.991302,376.239929 289.650085,388.305298 276.406677,397.210358 
              C265.124878,404.796417 252.264389,407.450714 239.363708,409.781525 
              C235.303543,410.515076 230.798416,408.339722 226.461349,408.071777 
              C214.211761,407.314972 202.765137,403.003387 193.247162,396.225952 
              C178.570587,385.775146 166.650909,372.430847 160.866821,354.461670 
              C157.491714,343.976379 158.542816,333.385376 157.892731,322.790283 
              C157.187973,311.303894 160.858047,301.018097 165.564636,291.043884 
              C171.188828,279.125031 180.188263,269.734161 190.656067,262.028961 
              C203.257065,252.753571 217.883575,248.255646 233.375183,247.161011 
              C238.439896,246.803146 243.677505,248.113388 248.768097,249.035736 
              C270.396240,252.954407 287.735168,263.414551 299.216034,282.618317 
              C301.691895,286.759674 304.439697,290.776642 306.494507,295.119507 
              C308.168945,298.658508 310.322388,298.489136 313.240417,297.314667 
              C325.982056,292.186340 338.724304,287.058624 351.500366,282.016937 
              C359.483459,278.866608 367.534393,275.888489 375.540955,272.797089 
              C380.006653,271.072845 380.947418,268.771667 379.426270,263.889252 
              C375.639862,251.735733 368.414185,241.341904 360.713257,231.689713 
              C352.742493,221.699295 343.416809,212.503540 333.487946,204.430984 
              C319.713074,193.231491 303.833191,185.524277 286.734131,180.141418 
              C271.921082,175.478241 256.799164,172.834000 241.468170,172.174057 
              C220.201050,171.258606 199.454498,174.401794 179.219269,181.772141 
              C159.211517,189.059631 141.253204,199.282715 125.713783,213.790436 
              C113.817627,224.896805 103.659500,237.415833 96.088768,251.836517 
              C91.332306,260.896606 87.553253,270.311462 84.451332,280.220032 
              C81.281570,290.345215 78.569550,300.365143 78.128693,310.821228 
              C77.588669,323.629303 77.891922,336.478943 78.065338,349.307434 
              C78.117897,353.195190 78.418556,357.231659 79.526756,360.923462 
              C82.409363,370.526489 86.205620,379.863892 88.895889,389.513947 
              C92.663071,403.026947 100.731186,414.107910 108.819855,424.979004 
              C114.924675,433.183868 122.396164,440.555969 130.116211,447.320892 
              C137.242569,453.565613 145.122589,459.197662 153.380737,463.835114 
              C161.957382,468.651459 171.186218,472.526245 180.496384,475.756317 
              C190.294510,479.155731 200.385544,482.419708 210.605408,483.711975 
              C222.867783,485.262573 235.409119,485.075714 247.815109,484.848267 
              C255.398743,484.709259 263.074585,483.617767 270.490479,481.970276 
              C278.101776,480.279388 285.421906,477.307831 292.913696,475.042969 
              C309.871887,469.916321 324.513855,460.739777 338.512207,448.993500 
            M1356.000000,235.487869 
              C1356.000000,238.987366 1356.137695,242.493942 1355.958618,245.984253 
              C1355.801636,249.043411 1357.011230,250.092926 1360.037842,250.047867 
              C1369.034058,249.914001 1378.033569,249.999969 1387.031738,250.000000 
              C1394.313477,250.000031 1401.595215,250.000000 1408.796631,250.000000 
              C1409.236816,254.118683 1409.908081,257.685486 1409.956055,261.260651 
              C1410.553223,305.924103 1408.865356,350.604309 1411.841064,395.257538 
              C1413.083618,413.900116 1417.840942,431.284241 1427.193359,447.176208 
              C1433.619019,458.094879 1442.768311,466.801361 1454.282959,472.765076 
              C1465.298828,478.470490 1477.039307,481.042999 1489.176514,483.390533 
              C1505.261353,486.501587 1520.932007,484.686371 1536.602783,482.467682 
              C1544.191406,481.393311 1551.525757,477.928925 1558.739746,474.971832 
              C1565.747681,472.099213 1572.736328,468.958099 1579.200439,465.052704 
              C1584.022461,462.139404 1584.497070,459.277130 1581.772949,454.590759 
              C1572.401489,438.468353 1562.503296,422.650085 1553.249268,406.462402 
              C1549.373535,399.682587 1548.345459,398.070221 1539.858887,403.411713 
              C1531.602173,408.608521 1522.827515,412.481567 1512.312866,409.114014 
              C1501.851074,405.763336 1493.675781,397.612793 1492.093384,387.520966 
              C1490.931519,380.110962 1490.137939,372.563843 1490.090820,365.072113 
              C1489.881470,331.746582 1490.049072,298.418884 1489.946899,265.092346 
              C1489.931641,260.119263 1489.205811,255.148361 1488.794678,250.000000 
              C1513.512085,250.000000 1537.332764,249.944809 1561.152588,250.051651 
              C1565.367188,250.070557 1567.081665,248.557800 1567.055176,244.245621 
              C1566.930908,224.083649 1566.931152,203.920059 1567.054932,183.758087 
              C1567.081421,179.449921 1565.375122,177.927124 1561.156250,177.948044 
              C1538.827759,178.058731 1516.498535,178.000000 1494.169556,178.000000 
              C1492.555786,178.000000 1490.941895,178.000000 1489.017578,178.000000 
              C1489.017578,141.779266 1489.017578,106.013947 1489.017578,69.531242 
              C1485.614868,71.056221 1482.573730,72.073898 1479.889893,73.686562 
              C1471.756836,78.573784 1463.877808,83.889465 1455.686523,88.673035 
              C1443.239746,95.941772 1430.658936,102.985329 1418.043213,109.958496 
              C1412.418701,113.067413 1409.437500,116.715179 1409.767578,123.970177 
              C1410.509277,140.266571 1410.000000,156.619904 1410.000000,172.950058 
              C1410.000000,174.552353 1410.000000,176.154648 1410.000000,178.000000 
              C1393.322144,178.000000 1377.183472,178.116440 1361.048828,177.916641 
              C1357.103882,177.867798 1355.866455,178.994400 1355.913696,183.003448 
              C1356.116211,200.164368 1356.000000,217.329071 1356.000000,235.487869 
            M821.000305,234.529816 
              C814.999451,218.181442 808.979919,201.839890 803.010742,185.479950 
              C801.509399,181.364944 799.942505,177.886383 794.426758,177.925476 
              C770.099487,178.097961 745.769775,178.082291 721.442322,177.926544 
              C716.896484,177.897430 716.191956,180.177139 717.282715,183.519684 
              C719.253479,189.559402 721.595337,195.480164 723.852966,201.423737 
              C729.181396,215.451797 734.588745,229.449951 739.894470,243.486542 
              C745.662292,258.745331 751.285950,274.058807 757.092041,289.302856 
              C763.749573,306.782410 770.519104,324.219421 777.277649,341.660309 
              C781.784729,353.291260 786.403625,364.878906 790.889526,376.517975 
              C796.633972,391.422333 802.297791,406.357758 807.991272,421.281738 
              C814.823120,439.189606 821.643188,457.101959 828.484436,475.006256 
              C829.599731,477.925201 831.545776,479.154785 834.893250,479.081940 
              C845.219666,478.857269 855.554016,479.000000 865.885315,479.000000 
              C880.176880,479.000000 894.468384,479.000000 908.976013,479.000000 
              C912.382446,470.627625 915.783386,462.523193 918.983398,454.340240 
              C923.115662,443.773590 926.982178,433.102539 931.158081,422.553619 
              C935.282166,412.135406 939.792725,401.869598 943.878296,391.436859 
              C951.348389,372.361206 958.552063,353.181213 966.014282,334.102417 
              C972.467773,317.602600 979.189270,301.207703 985.671509,284.718964 
              C990.224548,273.137482 994.442566,261.423645 999.047241,249.863312 
              C1005.910156,232.633591 1013.391541,215.636581 1019.747437,198.225754 
              C1022.038696,191.949402 1027.274536,186.059006 1024.445190,178.000000 
              C1023.093750,178.000000 1021.467834,178.000000 1019.841919,178.000000 
              C996.513245,178.000000 973.183044,178.137039 949.856934,177.892822 
              C944.742920,177.839294 942.422119,180.203247 940.998535,184.477081 
              C938.480408,192.037079 936.116638,199.655029 933.361145,207.128113 
              C926.675598,225.259781 919.711975,243.288956 913.034729,261.423615 
              C908.282227,274.331024 903.928833,287.385254 899.188049,300.297089 
              C893.507935,315.767273 887.623047,331.162445 881.791687,346.576843 
              C878.585022,355.053162 875.306335,363.502197 871.511292,373.393921 
              C868.346619,364.339294 865.841125,356.636353 862.965088,349.074371 
              C859.209961,339.200775 854.948547,329.517090 851.301697,319.605713 
              C847.934204,310.453613 845.281372,301.039368 841.950073,291.872803 
              C839.662842,285.579163 836.465393,279.616119 834.182922,273.321075 
              C829.616821,260.727997 825.399475,248.008438 821.000305,234.529816 
            M2591.997803,274.207520 
              C2591.665283,276.459229 2591.015625,278.716003 2591.051758,280.961792 
              C2591.284180,295.377136 2591.746094,309.788849 2591.971680,324.204285 
              C2592.120361,333.698364 2592.000000,343.196686 2592.000000,352.693115 
              C2592.000000,388.512970 2591.992676,424.332794 2592.008301,460.152649 
              C2592.010742,465.377625 2593.177979,466.124481 2597.725098,463.677002 
              C2603.806885,460.403503 2609.840576,457.037781 2615.838623,453.612427 
              C2634.815674,442.774780 2653.741699,431.847534 2672.734375,421.037323 
              C2690.136719,411.132294 2707.604004,401.342255 2725.032715,391.483734 
              C2729.367920,389.031403 2733.632812,386.453979 2737.984375,384.031525 
              C2748.770996,378.026550 2759.638916,372.166016 2770.381104,366.083221 
              C2782.260254,359.356720 2794.015137,352.411011 2805.863525,345.630005 
              C2814.473145,340.702606 2823.157959,335.906586 2831.788086,331.014038 
              C2835.280029,329.034393 2835.248779,326.979462 2831.762939,324.971375 
              C2827.160889,322.320496 2822.600586,319.595978 2817.963379,317.008850 
              C2805.659668,310.144745 2793.286865,303.403595 2781.010254,296.491455 
              C2764.236816,287.047180 2747.556396,277.436676 2730.779297,267.998596 
              C2717.892334,260.748871 2704.868896,253.741714 2691.994629,246.470139 
              C2675.928467,237.395599 2659.955566,228.155594 2643.937256,218.996201 
              C2631.941406,212.136841 2620.119629,204.937576 2607.846191,198.616119 
              C2602.966553,196.102722 2598.976807,190.676987 2592.000000,192.261169 
              C2592.000000,219.321106 2592.000000,246.285751 2591.997803,274.207520 
            M1777.532837,174.000000 
              C1748.685059,174.365646 1726.959961,187.862335 1709.838013,210.905838 
              C1709.000000,201.654572 1708.852295,192.791214 1709.060547,183.936249 
              C1709.168579,179.344162 1707.255249,177.906387 1702.834229,177.935226 
              C1681.007935,178.077591 1659.180298,177.999969 1637.353149,178.000031 
              C1630.003418,178.000046 1630.000488,178.000153 1630.000488,185.312668 
              C1629.999756,281.452087 1630.000000,377.591492 1630.000000,473.730927 
              C1630.000000,475.353821 1630.000000,476.976746 1630.000000,478.633087 
              C1656.572754,478.633087 1682.757080,478.633087 1710.000000,478.633087 
              C1710.000000,463.021820 1710.000000,447.772583 1710.000000,432.523315 
              C1710.000000,393.867615 1709.822266,355.210449 1710.137573,316.557312 
              C1710.207397,307.991547 1710.811890,299.076202 1713.261475,290.952332 
              C1719.767944,269.372803 1735.883911,256.512177 1757.535522,254.347076 
              C1774.785767,252.622070 1792.631592,252.213379 1808.344360,262.597534 
              C1809.061646,263.071533 1811.584106,262.248108 1812.090698,261.359283 
              C1814.299683,257.483521 1816.357300,253.468369 1817.948975,249.304642 
              C1821.705566,239.476242 1825.153809,229.530151 1828.747681,219.639313 
              C1832.352295,209.719620 1835.989380,199.811798 1839.596680,189.893112 
              C1840.718994,186.806763 1840.197998,184.432617 1836.722290,183.289185 
              C1834.145874,182.441650 1831.507446,181.685089 1829.073364,180.519257 
              C1820.187988,176.263397 1810.827881,174.144073 1801.017212,174.018997 
              C1793.520508,173.923401 1786.021729,174.000000 1777.532837,174.000000 
            M3121.999023,577.138245 
              C3123.510254,567.582336 3124.399902,558.282654 3118.053223,549.669312 
              C3111.582275,540.887451 3095.445801,533.819275 3086.436279,537.281433 
              C3073.370117,542.302368 3062.890381,549.769775 3063.753906,568.112122 
              C3064.294678,579.600525 3068.332031,588.276550 3078.233643,593.434753 
              C3083.210938,596.027649 3089.455322,598.211426 3094.813721,597.640442 
              C3107.129883,596.328308 3117.073242,590.255798 3121.999023,577.138245 
            z"
        />
        <path
          fill="#FFFFFF"
          opacity="1.000000"
          stroke="none"
          d="
            M2781.728516,274.283875 
              C2763.936768,264.178986 2746.399170,254.387039 2728.955322,244.430435 
              C2720.581787,239.650909 2712.496826,234.362320 2704.083740,229.656876 
              C2691.481689,222.608200 2678.618652,216.024780 2666.025391,208.960556 
              C2650.632080,200.325699 2635.414062,191.379791 2620.097412,182.607727 
              C2614.567627,179.440552 2608.972412,176.387192 2603.406982,173.281891 
              C2603.456055,172.670029 2603.505127,172.058182 2603.554199,171.446320 
              C2605.909424,169.896027 2608.184570,168.204712 2610.633057,166.819473 
              C2621.938965,160.423279 2633.355713,154.220642 2644.615479,147.744827 
              C2660.755615,138.462204 2676.740479,128.909042 2692.895020,119.651352 
              C2703.440430,113.608147 2714.219238,107.973640 2724.804199,101.997375 
              C2743.974365,91.173645 2763.044678,80.172791 2782.219727,69.357635 
              C2796.776367,61.147388 2811.462402,53.166504 2826.029541,44.974724 
              C2834.413330,40.260147 2842.760986,35.469276 2850.957275,30.439516 
              C2855.459229,27.676798 2859.450195,27.690945 2863.993408,30.387745 
              C2877.401367,38.346603 2890.939697,46.087265 2904.466797,53.844257 
              C2920.634277,63.115551 2936.790039,72.409760 2953.052002,81.513603 
              C2964.384521,87.857880 2975.986816,93.722397 2987.281738,100.130730 
              C2996.231689,105.208542 3004.798828,110.957657 3013.718994,116.090782 
              C3021.470947,120.551811 3029.555176,124.431656 3037.358398,128.807999 
              C3054.315918,138.318497 3071.170166,148.013199 3088.103516,157.567139 
              C3094.490479,161.170807 3101.035889,164.496048 3107.379150,168.172882 
              C3108.857422,169.029816 3110.502686,170.686081 3110.752441,172.193130 
              C3110.919434,173.199478 3108.968018,174.966019 3107.597656,175.756241 
              C3088.941406,186.513214 3070.267334,197.241043 3051.498535,207.800186 
              C3040.905518,213.759918 3030.044434,219.244125 3019.463867,225.225586 
              C3010.110840,230.513138 3001.063965,236.340561 2991.727295,241.658600 
              C2981.863281,247.277237 2971.757324,252.470932 2961.864990,258.041626 
              C2951.220947,264.035492 2940.739502,270.317474 2930.117432,276.351196 
              C2920.776855,281.656921 2911.312744,286.745300 2901.952148,292.016418 
              C2889.231445,299.179657 2876.602539,306.506653 2863.837158,313.588196 
              C2859.823975,315.814423 2856.250977,316.423737 2851.404541,313.404144 
              C2838.462646,305.340851 2824.788818,298.456207 2811.437988,291.044922 
              C2801.605957,285.587158 2791.825195,280.037750 2781.728516,274.283875 
            z"
        />
        <path
          fill="#FFFFFF"
          opacity="1.000000"
          stroke="none"
          d="
            M2978.705322,560.729248 
              C2938.123535,583.658936 2897.840820,606.354004 2857.197754,629.251953 
              C2843.951416,621.545471 2830.713135,613.717834 2817.353271,606.103821 
              C2801.343750,596.979614 2785.239502,588.021484 2769.160156,579.020630 
              C2741.143799,563.337769 2713.109131,547.686768 2685.093506,532.002380 
              C2673.895020,525.732910 2662.723145,519.415466 2651.544434,513.110840 
              C2636.714111,504.746735 2621.882812,496.384460 2607.065674,487.997406 
              C2603.198242,485.808502 2602.774414,483.467621 2606.236572,481.407318 
              C2617.261475,474.845886 2628.412354,468.494110 2639.570557,462.160461 
              C2649.160889,456.716736 2658.789307,451.337402 2668.471924,446.060150 
              C2679.713135,439.933563 2691.098389,434.069641 2702.292480,427.859375 
              C2709.319092,423.961182 2716.016113,419.471619 2723.024170,415.537842 
              C2736.030762,408.236755 2749.224854,401.268616 2762.214355,393.937500 
              C2775.235596,386.588440 2788.090332,378.944214 2801.040771,371.468933 
              C2812.852783,364.650696 2824.684814,357.866821 2836.529541,351.105499 
              C2841.827393,348.081451 2846.984863,344.681793 2852.585449,342.372284 
              C2855.391602,341.214935 2859.682861,340.934174 2862.215576,342.289001 
              C2876.643311,350.006958 2890.720459,358.377411 2904.961426,366.447571 
              C2917.108154,373.331116 2929.336670,380.070160 2941.489258,386.943237 
              C2957.690674,396.106232 2973.831543,405.376129 2990.040283,414.525909 
              C3002.220703,421.401764 3014.502197,428.098083 3026.675537,434.986053 
              C3045.132568,445.429199 3063.530029,455.978088 3081.962891,466.463989 
              C3090.488525,471.313934 3099.039551,476.118683 3107.576660,480.948395 
              C3112.303711,483.622742 3112.477539,485.241364 3107.748047,487.976196 
              C3094.839355,495.440613 3081.795410,502.670593 3068.819824,510.019623 
              C3050.776611,520.238708 3032.771484,530.525146 3014.702393,540.698669 
              C3002.846436,547.374146 2990.906738,553.901062 2978.705322,560.729248 
            z"
        />
        <path
          fill="#FFFFFF"
          opacity="1.000000"
          stroke="none"
          d="
            M1069.749512,439.249695 
              C1063.160278,431.332184 1055.843140,424.263947 1050.697144,415.865387 
              C1041.577637,400.981659 1034.219482,385.086060 1031.064697,367.675018 
              C1029.734619,360.333649 1028.545532,352.910065 1028.118774,345.476410 
              C1027.613403,336.673035 1027.801147,327.813171 1028.037476,318.987152 
              C1028.731079,293.083344 1036.179565,269.281982 1049.343384,246.895905 
              C1057.586670,232.877487 1068.326416,221.234985 1080.140625,210.556244 
              C1094.751709,197.349411 1111.891357,188.287933 1130.503540,181.609421 
              C1142.922852,177.153061 1155.509155,174.370605 1168.532837,172.978104 
              C1180.826172,171.663666 1193.015625,171.065964 1205.266113,173.880127 
              C1214.080200,175.904953 1223.297363,176.302094 1231.999268,178.662186 
              C1247.661377,182.910080 1262.134766,189.757874 1275.747437,198.952866 
              C1294.714722,211.764801 1309.595215,228.187195 1320.697876,247.762146 
              C1329.237061,262.817200 1336.106445,279.190704 1337.667847,296.524353 
              C1339.405518,315.814941 1338.715576,335.328583 1338.855835,354.746796 
              C1338.863647,355.823120 1336.952271,357.188354 1335.650879,357.904419 
              C1334.755371,358.397186 1333.369751,357.999939 1332.203247,357.999939 
              C1284.541870,358.000000 1236.880493,358.000000 1189.219116,358.000000 
              C1161.640747,358.000000 1134.062256,358.000000 1106.301514,358.000000 
              C1108.368530,371.114868 1115.090698,380.519012 1122.825073,389.254059 
              C1134.667358,402.628387 1149.936035,410.690765 1167.178955,413.647766 
              C1177.704956,415.452881 1188.795044,414.193939 1199.621704,413.914856 
              C1204.283691,413.794708 1209.006714,413.031830 1213.552124,411.937958 
              C1229.951294,407.991364 1242.564819,398.268616 1252.958130,385.349335 
              C1254.880005,382.960449 1256.310059,379.998352 1258.654175,378.192688 
              C1260.092163,377.085022 1263.372314,376.757324 1264.906006,377.653107 
              C1273.356445,382.588287 1281.395264,388.225769 1289.821777,393.205170 
              C1299.436401,398.886658 1309.341675,404.074554 1319.047363,409.605530 
              C1321.304077,410.891663 1323.264526,412.697754 1325.412842,414.303040 
              C1317.120117,428.581512 1306.137207,439.896362 1294.214722,449.820648 
              C1279.780151,461.835968 1263.454224,470.773346 1245.164795,476.773682 
              C1221.105591,484.666992 1196.685059,485.754028 1171.965576,484.821747 
              C1160.371460,484.384521 1148.771240,482.739899 1137.515381,479.231720 
              C1121.263184,474.166260 1105.293579,468.492767 1091.643921,458.012604 
              C1084.124146,452.239014 1077.195068,445.695953 1069.749512,439.249695 
            M1117.969360,269.549774 
              C1112.016479,277.908600 1106.223267,286.348175 1104.048218,296.762085 
              C1157.099365,296.762085 1209.965698,296.762085 1263.722534,296.762085 
              C1261.366089,290.635162 1259.708252,284.747314 1256.904053,279.468384 
              C1253.992798,273.987885 1249.908813,269.138794 1246.450073,263.938873 
              C1239.653320,253.720490 1229.190308,248.467361 1218.427246,244.128128 
              C1202.884766,237.861938 1186.557129,236.202408 1169.994873,239.069702 
              C1159.695801,240.852722 1149.833008,244.144821 1140.796631,249.629700 
              C1132.237427,254.824905 1124.662109,261.114227 1117.969360,269.549774 
            z"
        />
        <path
          fill="#FFFFFF"
          opacity="1.000000"
          stroke="none"
          d="
            M621.347046,475.261780 
              C610.811401,478.265778 600.753845,482.452271 590.382751,483.482605 
              C576.026367,484.908905 561.433838,483.931702 546.942810,484.038177 
              C535.608398,484.121460 524.793945,481.576996 514.095703,478.065704 
              C496.908752,472.424622 480.412384,465.209106 466.468201,453.625122 
              C453.707855,443.024536 441.138336,431.927185 432.252197,417.610168 
              C427.712769,410.296387 424.145966,402.385742 419.948578,394.851257 
              C412.130707,380.817963 408.377228,365.567139 407.126801,349.775970 
              C406.147797,337.412201 405.072968,324.832336 406.279633,312.568787 
              C408.364990,291.375702 413.560028,270.926300 424.813477,252.216949 
              C433.535736,237.715668 443.205231,224.162720 455.750824,212.825729 
              C467.062683,202.603561 479.491241,193.791550 493.602600,187.950684 
              C505.382965,183.074661 517.354797,177.814484 529.759277,175.508759 
              C545.073853,172.662140 560.683716,170.590103 576.646973,172.721909 
              C588.239868,174.270035 599.783691,175.529526 610.987610,178.977493 
              C626.649109,183.797287 641.949097,189.561432 655.033020,199.680908 
              C664.316223,206.860870 673.400330,214.402786 681.843994,222.539963 
              C695.206604,235.417618 704.080566,251.477692 711.607605,268.240326 
              C716.642639,279.453186 719.641724,291.344360 720.912903,303.544342 
              C722.002197,313.998657 723.108765,324.553772 722.814270,335.025116 
              C722.395630,349.909454 720.023926,364.517212 715.245117,378.869965 
              C710.171387,394.108398 703.166199,408.252441 693.812500,421.027557 
              C685.013000,433.045898 674.853821,444.005707 662.669495,452.994507 
              C650.275146,462.138153 637.087341,469.613434 622.678955,474.979980 
              C622.381897,475.090637 622.017944,475.021790 621.347046,475.261780 
            M602.953735,400.560883 
              C608.734192,396.108459 614.834839,392.005402 620.193909,387.093323 
              C624.497375,383.148743 628.795105,378.699921 631.501709,373.624969 
              C635.837708,365.494812 639.516602,356.868011 642.263611,348.073273 
              C645.763428,336.868286 646.117004,325.126556 643.754272,313.598022 
              C640.050781,295.527100 631.834778,279.842377 617.908386,267.368286 
              C605.555359,256.303497 591.382874,248.807358 574.862000,247.135742 
              C554.712158,245.096954 535.618652,248.721100 518.869507,261.018005 
              C505.295380,270.983887 494.979004,283.567322 489.254761,299.498291 
              C485.409851,310.198944 483.808228,321.355713 485.042450,332.741425 
              C485.757111,339.334259 486.282959,346.043243 487.966125,352.416809 
              C492.374603,369.110168 502.136658,382.281525 515.508362,393.156738 
              C527.567932,402.964752 541.459229,408.082031 556.500305,409.858643 
              C572.541870,411.753418 587.841858,408.110474 602.953735,400.560883 
            z"
        />
        <path
          fill="#FFFFFF"
          opacity="1.000000"
          stroke="none"
          d="
            M1942.000000,240.000000 
              C1942.000000,252.998825 1941.901001,265.498596 1942.020142,277.996277 
              C1942.289429,306.246735 1942.378784,334.504822 1943.229980,362.739075 
              C1943.411865,368.768494 1946.155273,374.847870 1948.357422,380.662292 
              C1952.725342,392.195099 1960.001831,401.545258 1971.428345,406.754181 
              C1977.178589,409.375427 1983.348755,411.904755 1989.532715,412.563934 
              C2000.752075,413.759796 2012.395508,414.338867 2023.037720,409.831970 
              C2034.317139,405.055237 2043.235474,396.936371 2049.883057,386.488739 
              C2055.935791,376.976654 2059.008545,366.627747 2059.005615,355.345306 
              C2058.992676,308.183105 2058.941406,261.020813 2059.045410,213.858841 
              C2059.068359,203.439941 2059.761719,193.024094 2059.958252,182.603317 
              C2060.050781,177.683136 2064.054199,178.396576 2066.634277,178.151199 
              C2071.919189,177.648560 2077.285645,178.000031 2082.618408,178.000015 
              C2101.916260,177.999969 2121.214111,178.000000 2140.755371,178.000000 
              C2140.755371,278.369141 2140.755371,378.434143 2140.755371,478.749695 
              C2114.971436,478.749695 2089.234375,478.749695 2063.356201,478.749695 
              C2062.850342,468.877319 2062.345947,459.037811 2061.786865,448.131714 
              C2058.406006,450.980072 2055.329834,453.103424 2052.824463,455.764160 
              C2042.591187,466.632660 2030.293823,474.463165 2016.272217,479.022705 
              C2007.169067,481.982849 1997.528931,484.039032 1987.999512,484.742615 
              C1977.331909,485.530151 1966.385498,485.250397 1955.806885,483.725708 
              C1946.412598,482.371643 1937.367065,478.637115 1928.145996,476.029541 
              C1920.631226,473.904480 1914.326050,469.681610 1907.764526,465.572784 
              C1896.498291,458.517975 1887.971924,449.083923 1881.088501,438.095490 
              C1872.151001,423.827911 1865.326660,408.646515 1863.990234,391.521729 
              C1862.996216,378.783844 1861.207886,366.050812 1861.136108,353.307953 
              C1860.820312,297.315033 1860.999634,241.319336 1861.000366,185.324646 
              C1861.000488,178.000168 1861.003174,178.000061 1868.343750,178.000031 
              C1890.508301,177.999969 1912.672852,177.999908 1934.837402,178.000046 
              C1941.998413,178.000092 1941.999390,178.000366 1941.999756,185.505783 
              C1942.000366,203.503860 1942.000000,221.501923 1942.000000,240.000000 
            z"
        />
        <path
          fill="#FFFFFF"
          opacity="1.000000"
          stroke="none"
          d="
            M2447.298584,229.799500 
              C2452.158447,238.038406 2452.212891,238.174759 2444.055664,241.435699 
              C2426.546143,248.435257 2408.966553,255.258987 2391.437256,262.208893 
              C2388.632324,263.320923 2385.811035,264.498291 2383.223145,266.027191 
              C2379.127930,268.446472 2378.019043,265.192230 2375.924316,262.907715 
              C2370.624512,257.127563 2365.640137,250.756790 2359.361816,246.249222 
              C2350.940918,240.203445 2341.245361,236.410095 2330.361572,236.947144 
              C2324.376465,237.242493 2318.324463,237.442307 2312.373779,236.901947 
              C2302.038818,235.963486 2293.892822,241.028107 2285.986572,246.240158 
              C2283.612549,247.805176 2282.355225,251.846909 2281.649170,254.992538 
              C2280.280029,261.093292 2279.401611,267.858032 2284.446289,272.521606 
              C2288.071777,275.873230 2293.020996,278.105255 2297.733643,279.913910 
              C2317.343262,287.439606 2338.185059,290.165710 2358.447998,295.166290 
              C2373.032715,298.765594 2387.740234,302.691132 2401.514893,308.539368 
              C2418.488281,315.745728 2433.683105,326.246216 2443.811523,342.397980 
              C2449.415771,351.334747 2453.494873,360.924408 2454.019287,371.709381 
              C2454.242432,376.297394 2454.798584,380.870544 2454.976074,385.459259 
              C2455.601318,401.633026 2450.945557,416.294128 2442.532471,430.023682 
              C2429.752686,450.878937 2412.095703,465.807678 2389.188232,474.250885 
              C2380.354980,477.506561 2371.180176,479.864319 2362.093262,482.387024 
              C2358.829590,483.293030 2355.377930,483.831848 2351.993164,483.937988 
              C2336.912842,484.410645 2321.775879,485.572479 2306.754395,484.749542 
              C2291.164062,483.895447 2275.489502,482.063232 2260.892090,475.465851 
              C2258.009277,474.162933 2254.440430,474.297058 2251.665771,472.851318 
              C2243.038574,468.356323 2234.461426,463.710968 2226.191895,458.594940 
              C2208.976562,447.944031 2196.731934,432.715668 2187.512207,414.933990 
              C2186.378418,412.747498 2186.176270,410.078003 2185.474121,407.368652 
              C2211.675781,398.612061 2236.024170,386.761658 2261.886230,378.672913 
              C2268.375244,392.896301 2278.436523,402.289429 2289.871582,409.965118 
              C2295.149170,413.507660 2301.838867,415.447357 2308.168945,416.788116 
              C2315.318848,418.302521 2322.839111,419.230988 2330.099854,418.790649 
              C2341.311279,418.110657 2352.853027,417.248383 2362.049072,409.422852 
              C2375.687500,397.816650 2379.181641,380.759277 2360.319336,372.117065 
              C2349.500000,367.160004 2337.716064,364.040314 2326.103760,361.148956 
              C2311.579834,357.532684 2296.734619,355.224976 2282.133301,351.892853 
              C2276.107910,350.517853 2270.331787,348.013153 2264.484863,345.904205 
              C2258.332275,343.685028 2252.077393,341.661835 2246.134766,338.963593 
              C2227.248535,330.388184 2211.755371,317.902893 2203.891602,298.144684 
              C2200.958008,290.774170 2198.515869,282.997803 2198.876953,274.579193 
              C2199.414551,262.037109 2198.627441,249.675507 2203.610840,237.407806 
              C2210.153564,221.301178 2219.895264,208.091614 2233.827148,198.152557 
              C2242.009277,192.315308 2250.772217,187.023727 2259.901367,182.862610 
              C2268.129639,179.112000 2277.118408,176.859314 2285.949951,174.661926 
              C2292.051514,173.143829 2298.436768,172.372528 2304.730469,172.108856 
              C2314.545898,171.697601 2324.391602,172.028427 2334.224365,171.993607 
              C2350.612793,171.935593 2366.246582,175.134933 2381.771240,180.624802 
              C2392.195068,184.310913 2402.118652,188.521408 2411.136230,194.725540 
              C2425.035400,204.288086 2436.953369,215.989838 2447.298584,229.799500 
            z"
        />
        <path
          fill="#FFFFFF"
          opacity="1.000000"
          stroke="none"
          d="
            M338.255432,449.247803 
              C324.513855,460.739777 309.871887,469.916321 292.913696,475.042969 
              C285.421906,477.307831 278.101776,480.279388 270.490479,481.970276 
              C263.074585,483.617767 255.398743,484.709259 247.815109,484.848267 
              C235.409119,485.075714 222.867783,485.262573 210.605408,483.711975 
              C200.385544,482.419708 190.294510,479.155731 180.496384,475.756317 
              C171.186218,472.526245 161.957382,468.651459 153.380737,463.835114 
              C145.122589,459.197662 137.242569,453.565613 130.116211,447.320892 
              C122.396164,440.555969 114.924675,433.183868 108.819855,424.979004 
              C100.731186,414.107910 92.663071,403.026947 88.895889,389.513947 
              C86.205620,379.863892 82.409363,370.526489 79.526756,360.923462 
              C78.418556,357.231659 78.117897,353.195190 78.065338,349.307434 
              C77.891922,336.478943 77.588669,323.629303 78.128693,310.821228 
              C78.569550,300.365143 81.281570,290.345215 84.451332,280.220032 
              C87.553253,270.311462 91.332306,260.896606 96.088768,251.836517 
              C103.659500,237.415833 113.817627,224.896805 125.713783,213.790436 
              C141.253204,199.282715 159.211517,189.059631 179.219269,181.772141 
              C199.454498,174.401794 220.201050,171.258606 241.468170,172.174057 
              C256.799164,172.834000 271.921082,175.478241 286.734131,180.141418 
              C303.833191,185.524277 319.713074,193.231491 333.487946,204.430984 
              C343.416809,212.503540 352.742493,221.699295 360.713257,231.689713 
              C368.414185,241.341904 375.639862,251.735733 379.426270,263.889252 
              C380.947418,268.771667 380.006653,271.072845 375.540955,272.797089 
              C367.534393,275.888489 359.483459,278.866608 351.500366,282.016937 
              C338.724304,287.058624 325.982056,292.186340 313.240417,297.314667 
              C310.322388,298.489136 308.168945,298.658508 306.494507,295.119507 
              C304.439697,290.776642 301.691895,286.759674 299.216034,282.618317 
              C287.735168,263.414551 270.396240,252.954407 248.768097,249.035736 
              C243.677505,248.113388 238.439896,246.803146 233.375183,247.161011 
              C217.883575,248.255646 203.257065,252.753571 190.656067,262.028961 
              C180.188263,269.734161 171.188828,279.125031 165.564636,291.043884 
              C160.858047,301.018097 157.187973,311.303894 157.892731,322.790283 
              C158.542816,333.385376 157.491714,343.976379 160.866821,354.461670 
              C166.650909,372.430847 178.570587,385.775146 193.247162,396.225952 
              C202.765137,403.003387 214.211761,407.314972 226.461349,408.071777 
              C230.798416,408.339722 235.303543,410.515076 239.363708,409.781525 
              C252.264389,407.450714 265.124878,404.796417 276.406677,397.210358 
              C289.650085,388.305298 298.991302,376.239929 306.157745,362.307251 
              C308.101074,358.529205 310.636963,357.573761 314.256653,359.056366 
              C329.220734,365.185364 344.137024,371.431091 359.099060,377.565186 
              C364.575806,379.810547 370.099915,381.949280 375.657928,383.985016 
              C382.250763,386.399780 383.857697,388.739380 380.595306,394.622009 
              C375.065552,404.593079 369.189484,414.451965 362.538177,423.695374 
              C357.381592,430.861511 350.884918,437.076843 344.844299,443.585266 
              C342.968628,445.606140 340.635773,447.202698 338.255432,449.247803 
            z"
        />
        <path
          fill="#FFFFFF"
          opacity="1.000000"
          stroke="none"
          d="
            M1356.000000,234.990128 
              C1356.000000,217.329071 1356.116211,200.164368 1355.913696,183.003448 
              C1355.866455,178.994400 1357.103882,177.867798 1361.048828,177.916641 
              C1377.183472,178.116440 1393.322144,178.000000 1410.000000,178.000000 
              C1410.000000,176.154648 1410.000000,174.552353 1410.000000,172.950058 
              C1410.000000,156.619904 1410.509277,140.266571 1409.767578,123.970177 
              C1409.437500,116.715179 1412.418701,113.067413 1418.043213,109.958496 
              C1430.658936,102.985329 1443.239746,95.941772 1455.686523,88.673035 
              C1463.877808,83.889465 1471.756836,78.573784 1479.889893,73.686562 
              C1482.573730,72.073898 1485.614868,71.056221 1489.017578,69.531242 
              C1489.017578,106.013947 1489.017578,141.779266 1489.017578,178.000000 
              C1490.941895,178.000000 1492.555786,178.000000 1494.169556,178.000000 
              C1516.498535,178.000000 1538.827759,178.058731 1561.156250,177.948044 
              C1565.375122,177.927124 1567.081421,179.449921 1567.054932,183.758087 
              C1566.931152,203.920059 1566.930908,224.083649 1567.055176,244.245621 
              C1567.081665,248.557800 1565.367188,250.070557 1561.152588,250.051651 
              C1537.332764,249.944809 1513.512085,250.000000 1488.794678,250.000000 
              C1489.205811,255.148361 1489.931641,260.119263 1489.946899,265.092346 
              C1490.049072,298.418884 1489.881470,331.746582 1490.090820,365.072113 
              C1490.137939,372.563843 1490.931519,380.110962 1492.093384,387.520966 
              C1493.675781,397.612793 1501.851074,405.763336 1512.312866,409.114014 
              C1522.827515,412.481567 1531.602173,408.608521 1539.858887,403.411713 
              C1548.345459,398.070221 1549.373535,399.682587 1553.249268,406.462402 
              C1562.503296,422.650085 1572.401489,438.468353 1581.772949,454.590759 
              C1584.497070,459.277130 1584.022461,462.139404 1579.200439,465.052704 
              C1572.736328,468.958099 1565.747681,472.099213 1558.739746,474.971832 
              C1551.525757,477.928925 1544.191406,481.393311 1536.602783,482.467682 
              C1520.932007,484.686371 1505.261353,486.501587 1489.176514,483.390533 
              C1477.039307,481.042999 1465.298828,478.470490 1454.282959,472.765076 
              C1442.768311,466.801361 1433.619019,458.094879 1427.193359,447.176208 
              C1417.840942,431.284241 1413.083618,413.900116 1411.841064,395.257538 
              C1408.865356,350.604309 1410.553223,305.924103 1409.956055,261.260651 
              C1409.908081,257.685486 1409.236816,254.118683 1408.796631,250.000000 
              C1401.595215,250.000000 1394.313477,250.000031 1387.031738,250.000000 
              C1378.033569,249.999969 1369.034058,249.914001 1360.037842,250.047867 
              C1357.011230,250.092926 1355.801636,249.043411 1355.958618,245.984253 
              C1356.137695,242.493942 1356.000000,238.987366 1356.000000,234.990128 
            z"
        />
        <path
          fill="#FFFFFF"
          opacity="1.000000"
          stroke="none"
          d="
            M821.019287,234.935455 
              C825.399475,248.008438 829.616821,260.727997 834.182922,273.321075 
              C836.465393,279.616119 839.662842,285.579163 841.950073,291.872803 
              C845.281372,301.039368 847.934204,310.453613 851.301697,319.605713 
              C854.948547,329.517090 859.209961,339.200775 862.965088,349.074371 
              C865.841125,356.636353 868.346619,364.339294 871.511292,373.393921 
              C875.306335,363.502197 878.585022,355.053162 881.791687,346.576843 
              C887.623047,331.162445 893.507935,315.767273 899.188049,300.297089 
              C903.928833,287.385254 908.282227,274.331024 913.034729,261.423615 
              C919.711975,243.288956 926.675598,225.259781 933.361145,207.128113 
              C936.116638,199.655029 938.480408,192.037079 940.998535,184.477081 
              C942.422119,180.203247 944.742920,177.839294 949.856934,177.892822 
              C973.183044,178.137039 996.513245,178.000000 1019.841919,178.000000 
              C1021.467834,178.000000 1023.093750,178.000000 1024.445190,178.000000 
              C1027.274536,186.059006 1022.038696,191.949402 1019.747437,198.225754 
              C1013.391541,215.636581 1005.910156,232.633591 999.047241,249.863312 
              C994.442566,261.423645 990.224548,273.137482 985.671509,284.718964 
              C979.189270,301.207703 972.467773,317.602600 966.014282,334.102417 
              C958.552063,353.181213 951.348389,372.361206 943.878296,391.436859 
              C939.792725,401.869598 935.282166,412.135406 931.158081,422.553619 
              C926.982178,433.102539 923.115662,443.773590 918.983398,454.340240 
              C915.783386,462.523193 912.382446,470.627625 908.976013,479.000000 
              C894.468384,479.000000 880.176880,479.000000 865.885315,479.000000 
              C855.554016,479.000000 845.219666,478.857269 834.893250,479.081940 
              C831.545776,479.154785 829.599731,477.925201 828.484436,475.006256 
              C821.643188,457.101959 814.823120,439.189606 807.991272,421.281738 
              C802.297791,406.357758 796.633972,391.422333 790.889526,376.517975 
              C786.403625,364.878906 781.784729,353.291260 777.277649,341.660309 
              C770.519104,324.219421 763.749573,306.782410 757.092041,289.302856 
              C751.285950,274.058807 745.662292,258.745331 739.894470,243.486542 
              C734.588745,229.449951 729.181396,215.451797 723.852966,201.423737 
              C721.595337,195.480164 719.253479,189.559402 717.282715,183.519684 
              C716.191956,180.177139 716.896484,177.897430 721.442322,177.926544 
              C745.769775,178.082291 770.099487,178.097961 794.426758,177.925476 
              C799.942505,177.886383 801.509399,181.364944 803.010742,185.479950 
              C808.979919,201.839890 814.999451,218.181442 821.019287,234.935455 
            z"
        />
        <path
          fill="#FFFFFF"
          opacity="1.000000"
          stroke="none"
          d="
            M2591.999023,273.728943 
              C2592.000000,246.285751 2592.000000,219.321106 2592.000000,192.261169 
              C2598.976807,190.676987 2602.966553,196.102722 2607.846191,198.616119 
              C2620.119629,204.937576 2631.941406,212.136841 2643.937256,218.996201 
              C2659.955566,228.155594 2675.928467,237.395599 2691.994629,246.470139 
              C2704.868896,253.741714 2717.892334,260.748871 2730.779297,267.998596 
              C2747.556396,277.436676 2764.236816,287.047180 2781.010254,296.491455 
              C2793.286865,303.403595 2805.659668,310.144745 2817.963379,317.008850 
              C2822.600586,319.595978 2827.160889,322.320496 2831.762939,324.971375 
              C2835.248779,326.979462 2835.280029,329.034393 2831.788086,331.014038 
              C2823.157959,335.906586 2814.473145,340.702606 2805.863525,345.630005 
              C2794.015137,352.411011 2782.260254,359.356720 2770.381104,366.083221 
              C2759.638916,372.166016 2748.770996,378.026550 2737.984375,384.031525 
              C2733.632812,386.453979 2729.367920,389.031403 2725.032715,391.483734 
              C2707.604004,401.342255 2690.136719,411.132294 2672.734375,421.037323 
              C2653.741699,431.847534 2634.815674,442.774780 2615.838623,453.612427 
              C2609.840576,457.037781 2603.806885,460.403503 2597.725098,463.677002 
              C2593.177979,466.124481 2592.010742,465.377625 2592.008301,460.152649 
              C2591.992676,424.332794 2592.000000,388.512970 2592.000000,352.693115 
              C2592.000000,343.196686 2592.120361,333.698364 2591.971680,324.204285 
              C2591.746094,309.788849 2591.284180,295.377136 2591.051758,280.961792 
              C2591.015625,278.716003 2591.665283,276.459229 2591.999023,273.728943 
            z"
        />
        <path
          fill="#FFFFFF"
          opacity="1.000000"
          stroke="none"
          d="
            M1778.028320,174.000000 
              C1786.021729,174.000000 1793.520508,173.923401 1801.017212,174.018997 
              C1810.827881,174.144073 1820.187988,176.263397 1829.073364,180.519257 
              C1831.507446,181.685089 1834.145874,182.441650 1836.722290,183.289185 
              C1840.197998,184.432617 1840.718994,186.806763 1839.596680,189.893112 
              C1835.989380,199.811798 1832.352295,209.719620 1828.747681,219.639313 
              C1825.153809,229.530151 1821.705566,239.476242 1817.948975,249.304642 
              C1816.357300,253.468369 1814.299683,257.483521 1812.090698,261.359283 
              C1811.584106,262.248108 1809.061646,263.071533 1808.344360,262.597534 
              C1792.631592,252.213379 1774.785767,252.622070 1757.535522,254.347076 
              C1735.883911,256.512177 1719.767944,269.372803 1713.261475,290.952332 
              C1710.811890,299.076202 1710.207397,307.991547 1710.137573,316.557312 
              C1709.822266,355.210449 1710.000000,393.867615 1710.000000,432.523315 
              C1710.000000,447.772583 1710.000000,463.021820 1710.000000,478.633087 
              C1682.757080,478.633087 1656.572754,478.633087 1630.000000,478.633087 
              C1630.000000,476.976746 1630.000000,475.353821 1630.000000,473.730927 
              C1630.000000,377.591492 1629.999756,281.452087 1630.000488,185.312668 
              C1630.000488,178.000153 1630.003418,178.000046 1637.353149,178.000031 
              C1659.180298,177.999969 1681.007935,178.077591 1702.834229,177.935226 
              C1707.255249,177.906387 1709.168579,179.344162 1709.060547,183.936249 
              C1708.852295,192.791214 1709.000000,201.654572 1709.838013,210.905838 
              C1726.959961,187.862335 1748.685059,174.365646 1778.028320,174.000000 
            z"
        />
        <path
          fill="#FFFFFF"
          opacity="1.000000"
          stroke="none"
          d="
            M3121.991455,577.559448 
              C3117.073242,590.255798 3107.129883,596.328308 3094.813721,597.640442 
              C3089.455322,598.211426 3083.210938,596.027649 3078.233643,593.434753 
              C3068.332031,588.276550 3064.294678,579.600525 3063.753906,568.112122 
              C3062.890381,549.769775 3073.370117,542.302368 3086.436279,537.281433 
              C3095.445801,533.819275 3111.582275,540.887451 3118.053223,549.669312 
              C3124.399902,558.282654 3123.510254,567.582336 3121.991455,577.559448 
            M3070.955566,570.658447 
              C3071.127197,579.430725 3076.535400,584.613525 3083.688965,588.044250 
              C3090.781982,591.445923 3098.033691,591.273560 3104.617920,587.084412 
              C3101.666992,583.113159 3098.968262,579.280273 3096.049072,575.623230 
              C3094.114258,573.199524 3091.979980,570.741089 3088.401611,572.346191 
              C3087.946533,576.263123 3087.503662,580.076050 3087.081543,583.709534 
              C3084.668213,583.709534 3082.938721,583.709534 3081.232910,583.709534 
              C3081.232910,572.328430 3081.232910,561.238953 3081.232910,550.000183 
              C3086.764893,550.000183 3092.065674,549.858459 3097.355469,550.036255 
              C3103.897705,550.256042 3106.628418,553.589417 3107.120117,559.919556 
              C3107.488037,564.656067 3105.639160,567.801941 3102.050293,570.245361 
              C3104.692871,574.802979 3107.188477,579.106812 3109.848633,583.694824 
              C3119.326904,571.300476 3116.793701,559.052856 3110.716309,552.199341 
              C3103.739258,544.330933 3093.492432,542.339722 3084.280273,545.801086 
              C3074.833740,549.350525 3068.968750,560.385620 3070.955566,570.658447 
            M3087.974121,560.879944 
              C3087.638672,567.155823 3092.461426,564.969116 3095.264404,564.862183 
              C3100.719482,564.653870 3098.631104,560.397461 3099.026123,557.000671 
              C3095.825928,557.000671 3093.014893,556.723694 3090.311523,557.142944 
              C3089.294189,557.300842 3088.526611,559.072388 3087.974121,560.879944 
            z"
        />
        <path
          fill="none"
          opacity="1.000000"
          stroke="none"
          d="
            M1118.220459,269.283722 
              C1124.662109,261.114227 1132.237427,254.824905 1140.796631,249.629700 
              C1149.833008,244.144821 1159.695801,240.852722 1169.994873,239.069702 
              C1186.557129,236.202408 1202.884766,237.861938 1218.427246,244.128128 
              C1229.190308,248.467361 1239.653320,253.720490 1246.450073,263.938873 
              C1249.908813,269.138794 1253.992798,273.987885 1256.904053,279.468384 
              C1259.708252,284.747314 1261.366089,290.635162 1263.722534,296.762085 
              C1209.965698,296.762085 1157.099365,296.762085 1104.048218,296.762085 
              C1106.223267,286.348175 1112.016479,277.908600 1118.220459,269.283722 
            z"
        />
        <path
          fill="none"
          opacity="1.000000"
          stroke="none"
          d="
            M602.627136,400.766479 
              C587.841858,408.110474 572.541870,411.753418 556.500305,409.858643 
              C541.459229,408.082031 527.567932,402.964752 515.508362,393.156738 
              C502.136658,382.281525 492.374603,369.110168 487.966125,352.416809 
              C486.282959,346.043243 485.757111,339.334259 485.042450,332.741425 
              C483.808228,321.355713 485.409851,310.198944 489.254761,299.498291 
              C494.979004,283.567322 505.295380,270.983887 518.869507,261.018005 
              C535.618652,248.721100 554.712158,245.096954 574.862000,247.135742 
              C591.382874,248.807358 605.555359,256.303497 617.908386,267.368286 
              C631.834778,279.842377 640.050781,295.527100 643.754272,313.598022 
              C646.117004,325.126556 645.763428,336.868286 642.263611,348.073273 
              C639.516602,356.868011 635.837708,365.494812 631.501709,373.624969 
              C628.795105,378.699921 624.497375,383.148743 620.193909,387.093323 
              C614.834839,392.005402 608.734192,396.108459 602.627136,400.766479 
            z"
        />
        <path
          fill="none"
          opacity="1.000000"
          stroke="none"
          d="
            M3070.699219,570.307251 
              C3068.968750,560.385620 3074.833740,549.350525 3084.280273,545.801086 
              C3093.492432,542.339722 3103.739258,544.330933 3110.716309,552.199341 
              C3116.793701,559.052856 3119.326904,571.300476 3109.848633,583.694824 
              C3107.188477,579.106812 3104.692871,574.802979 3102.050293,570.245361 
              C3105.639160,567.801941 3107.488037,564.656067 3107.120117,559.919556 
              C3106.628418,553.589417 3103.897705,550.256042 3097.355469,550.036255 
              C3092.065674,549.858459 3086.764893,550.000183 3081.232910,550.000183 
              C3081.232910,561.238953 3081.232910,572.328430 3081.232910,583.709534 
              C3082.938721,583.709534 3084.668213,583.709534 3087.081543,583.709534 
              C3087.503662,580.076050 3087.946533,576.263123 3088.401611,572.346191 
              C3091.979980,570.741089 3094.114258,573.199524 3096.049072,575.623230 
              C3098.968262,579.280273 3101.666992,583.113159 3104.617920,587.084412 
              C3098.033691,591.273560 3090.781982,591.445923 3083.688965,588.044250 
              C3076.535400,584.613525 3071.127197,579.430725 3070.699219,570.307251 
            z"
        />
        <path
          fill="none"
          opacity="1.000000"
          stroke="none"
          d="
            M3087.809570,560.494141 
              C3088.526611,559.072388 3089.294189,557.300842 3090.311523,557.142944 
              C3093.014893,556.723694 3095.825928,557.000671 3099.026123,557.000671 
              C3098.631104,560.397461 3100.719482,564.653870 3095.264404,564.862183 
              C3092.461426,564.969116 3087.638672,567.155823 3087.809570,560.494141 
            z"
        />
      </svg>
    );
  }

  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 3248 722"
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
    >
      <path
        fill="none"
        opacity="1.000000"
        stroke="none"
        d="
          M2410.000000,723.000000 
            C1606.666626,723.000000 803.833313,723.000000 1.000000,723.000000 
            C1.000000,482.333344 1.000000,241.666672 1.000000,1.000000 
            C1083.666626,1.000000 2166.333252,1.000000 3249.000000,1.000000 
            C3249.000000,241.666672 3249.000000,482.333344 3249.000000,723.000000 
            C2969.500000,723.000000 2690.000000,723.000000 2410.000000,723.000000 
          M2623.582275,512.152344 
            C2624.662598,513.094421 2625.620117,514.251770 2626.841064,514.946594 
            C2648.387207,527.206116 2669.948975,539.438293 2691.539795,551.619019 
            C2755.879883,587.917053 2820.222656,624.210205 2884.647705,660.356812 
            C2886.248291,661.254944 2889.246338,661.193604 2890.873291,660.287781 
            C2922.562988,642.644409 2954.159668,624.833130 2985.746826,607.005859 
            C3031.673340,581.085999 3077.578857,555.128601 3123.489990,529.181396 
            C3132.690430,523.981445 3141.876221,518.755554 3152.266357,512.862549 
            C3063.611084,462.815918 2976.042725,413.382812 2888.864502,363.325745 
            C2976.328369,313.927826 3063.792236,264.529877 3152.094482,214.658340 
            C3149.779297,213.224915 3148.573242,212.416946 3147.312256,211.706314 
            C3110.092041,190.733337 3072.851562,169.796753 3035.645996,148.798248 
            C2987.729492,121.754173 2939.822510,94.692909 2891.979492,67.518883 
            C2888.825684,65.727486 2886.516357,65.698174 2883.355957,67.506081 
            C2856.806152,82.694374 2830.163330,97.721024 2803.523193,112.751175 
            C2744.595703,145.997589 2685.650146,179.211594 2626.743164,212.494507 
            C2625.600342,213.140213 2624.844482,214.470352 2623.450684,216.339661 
            C2623.416260,217.171066 2623.351562,218.002472 2623.351562,218.833878 
            C2623.340820,314.941132 2623.332520,411.048370 2623.353271,507.155670 
            C2623.353516,508.606201 2623.722900,510.056671 2623.582275,512.152344 
          M1234.500000,390.652924 
            C1278.945190,390.652924 1323.390503,390.652924 1367.976807,390.652924 
            C1368.122803,388.935608 1368.336426,387.791321 1368.299072,386.655243 
            C1367.797607,371.361450 1367.887329,356.015656 1366.594238,340.787689 
            C1364.364746,314.531799 1354.869873,290.742462 1339.237915,269.591125 
            C1315.197510,237.062454 1282.575806,218.592682 1242.941284,212.016113 
            C1204.076660,205.567307 1167.258667,211.522537 1133.408569,231.816742 
            C1094.292480,255.268005 1070.802734,290.183929 1061.927734,334.712921 
            C1058.805298,350.379669 1058.288696,366.303314 1060.045288,382.414124 
            C1062.183350,402.024170 1066.901611,420.794830 1075.960449,438.177460 
            C1100.081055,484.461975 1139.377686,509.598022 1190.182739,517.111938 
            C1215.374756,520.837830 1240.597534,519.320618 1265.456787,512.881958 
            C1293.957520,505.500122 1317.978760,490.867859 1337.821533,469.299164 
            C1343.270142,463.376709 1348.164795,456.944885 1353.369751,450.679352 
            C1352.020264,449.420197 1351.502075,448.727203 1350.813965,448.325256 
            C1331.047974,436.777771 1311.265015,425.259460 1291.492676,413.741089 
            C1265.115601,456.507324 1214.638062,459.515686 1180.161133,446.293182 
            C1152.932007,435.850281 1135.581177,409.558197 1133.555786,390.652802 
            C1166.898804,390.652802 1200.199463,390.652802 1234.500000,390.652924 
          M750.166626,384.737823 
            C752.775208,361.478119 751.416687,338.516754 743.999512,316.219635 
            C722.891357,252.764999 667.208801,213.320999 602.905762,209.863708 
            C563.707520,207.756195 527.826843,218.211395 496.539642,242.392288 
            C465.613342,266.294220 446.886475,297.974884 439.857330,336.213959 
            C436.076965,356.779510 436.561371,377.530151 441.157532,398.177277 
            C446.006073,419.958099 454.777954,439.856110 468.377075,457.425964 
            C496.182251,493.349823 532.884033,513.381409 578.134827,517.928040 
            C606.737183,520.801819 634.400330,517.048035 660.389771,504.949432 
            C711.341919,481.230225 741.253723,441.238739 750.166626,384.737823 
          M1970.795288,321.500000 
            C1970.795288,286.392059 1970.795288,251.284103 1970.795288,215.991180 
            C1944.486206,215.991180 1918.788574,215.991180 1892.798828,215.991180 
            C1892.798828,218.154343 1892.798828,219.964081 1892.798828,221.773834 
            C1892.798828,279.923706 1892.713623,338.073822 1892.856689,396.223328 
            C1892.894043,411.405365 1894.825806,426.436279 1899.045044,441.072205 
            C1906.968262,468.555908 1922.138916,490.649719 1947.574585,504.730316 
            C1962.478760,512.980896 1978.677490,516.875610 1995.628418,518.275024 
            C2033.844727,521.429871 2066.100586,510.079071 2090.905762,479.996155 
            C2091.555176,479.208740 2092.418213,478.597687 2094.125000,477.047516 
            C2094.125000,489.621582 2094.125000,500.985962 2094.125000,512.696777 
            C2096.559814,512.696777 2098.368408,512.707947 2100.177246,512.695007 
            C2121.498779,512.542664 2142.821533,512.222595 2164.141357,512.354126 
            C2169.100342,512.384644 2170.137939,510.780396 2170.131836,506.135590 
            C2170.007080,411.163147 2170.038330,316.190521 2170.038330,221.217941 
            C2170.038330,219.440338 2170.038330,217.662735 2170.038330,215.794312 
            C2144.065674,215.794312 2118.689697,215.794312 2092.812012,215.794312 
            C2092.812012,218.285507 2092.812012,220.239075 2092.812012,222.192627 
            C2092.812012,274.677490 2092.778809,327.162354 2092.838623,379.647156 
            C2092.851074,390.561401 2091.381592,401.151825 2087.660156,411.458771 
            C2073.456299,450.795959 2032.546997,458.260590 2002.546265,445.269257 
            C1982.369141,436.531830 1973.362671,418.886841 1971.943115,398.420441 
            C1970.194336,373.208405 1971.059570,347.815002 1970.795288,321.500000 
          M2223.691650,456.821869 
            C2241.812744,485.770813 2267.891113,503.921997 2300.724609,512.053772 
            C2313.719727,515.272339 2327.185547,517.120789 2340.549805,518.205017 
            C2365.268066,520.210388 2389.698486,518.314087 2413.320068,509.767395 
            C2443.788574,498.743286 2466.860107,479.780823 2478.413086,448.799835 
            C2485.457275,429.908997 2485.350586,410.627014 2478.473389,391.668121 
            C2470.719238,370.292694 2454.374756,357.180878 2434.579834,347.700500 
            C2413.703125,337.701935 2391.102783,333.611542 2368.797607,328.404297 
            C2353.786133,324.899811 2338.706299,321.288391 2324.172363,316.241089 
            C2307.506592,310.453461 2302.863037,295.151337 2313.604980,282.311707 
            C2317.512451,277.641266 2323.706787,273.800568 2329.591797,272.052521 
            C2357.408203,263.789856 2390.879150,270.058716 2408.295898,297.401062 
            C2409.781250,299.733063 2411.412354,299.965515 2413.727295,299.013672 
            C2427.229736,293.462097 2440.752197,287.960114 2454.262207,282.427002 
            C2462.492188,279.056244 2470.712158,275.659821 2479.254883,272.143921 
            C2478.645996,270.979797 2478.359131,270.242157 2477.917236,269.613617 
            C2465.399902,251.815231 2450.162109,236.965454 2430.946777,226.464493 
            C2409.636230,214.818375 2386.620361,209.885971 2362.538330,208.936447 
            C2334.898193,207.846664 2307.964844,210.647675 2283.052490,223.724960 
            C2254.541992,238.691147 2234.456055,260.489685 2230.952881,293.786163 
            C2228.001953,321.832336 2236.643066,345.600861 2260.297607,362.734528 
            C2272.583740,371.633850 2286.259766,377.667206 2300.735840,381.453613 
            C2320.647217,386.661804 2340.831787,390.826324 2360.904541,395.416016 
            C2372.894775,398.157562 2384.945801,400.747589 2395.562500,407.407654 
            C2404.675537,413.124603 2408.347900,422.536835 2404.006592,432.365479 
            C2401.623535,437.760223 2397.687012,443.000946 2393.180420,446.806793 
            C2385.479492,453.310303 2375.741943,455.333282 2365.744141,455.996460 
            C2334.322754,458.080811 2308.836670,448.189697 2292.453125,419.876190 
            C2290.951172,417.280670 2289.793945,416.522003 2286.602783,417.799683 
            C2268.575928,425.016998 2250.392822,431.843353 2232.290527,438.873322 
            C2227.267334,440.824188 2222.336914,443.014862 2217.089355,445.210449 
            C2219.385986,449.285797 2221.338379,452.749725 2223.691650,456.821869 
          M257.675232,518.781006 
            C278.948944,519.275452 299.757019,516.956787 320.008636,509.858154 
            C360.709290,495.591705 388.918884,467.704681 408.257141,429.965668 
            C411.296387,424.034576 411.077057,424.040955 404.752106,421.455292 
            C385.243286,413.480225 365.741760,405.485901 346.294983,397.361206 
            C340.116028,394.779724 340.198608,394.582092 337.246918,400.792511 
            C319.194489,438.775177 278.520844,455.708740 239.002640,441.694397 
            C197.650482,427.029602 175.099594,381.214478 188.122711,339.240387 
            C199.966858,301.066284 238.306427,274.777435 279.303864,282.134308 
            C304.523926,286.660004 322.844574,299.970612 334.841919,322.364868 
            C336.469421,325.402832 337.953613,328.517548 339.565155,331.717896 
            C341.358002,331.156097 342.806458,330.808807 344.172791,330.257935 
            C363.100891,322.625977 382.020538,314.972870 400.936127,307.309906 
            C409.520325,303.832275 409.634216,303.758301 405.558838,295.450378 
            C383.400574,250.278992 347.177338,223.085251 298.284210,212.856583 
            C274.396790,207.859207 250.372284,208.402359 226.477768,214.159561 
            C204.992004,219.336411 185.331802,228.217468 167.962326,241.843307 
            C136.201401,266.758820 117.351822,299.284882 110.978615,339.177551 
            C106.153465,369.380188 109.149239,398.794800 121.745232,426.519318 
            C147.984375,484.273224 194.040054,513.864136 257.675232,518.781006 
          M1557.500122,215.634537 
            C1544.552734,215.634537 1531.605469,215.634537 1518.044067,215.634537 
            C1518.044067,179.521729 1518.044067,143.997559 1518.044067,107.639259 
            C1515.482666,108.913376 1513.690918,109.672035 1512.029053,110.651405 
            C1490.412231,123.391167 1468.882446,136.281082 1447.142944,148.807373 
            C1443.560791,150.871368 1442.483643,153.047974 1442.523804,156.955154 
            C1442.709106,174.947617 1442.506470,192.944016 1442.683472,210.936646 
            C1442.720581,214.715332 1441.523315,215.771835 1437.833130,215.709869 
            C1425.673828,215.505676 1413.508789,215.634033 1401.345947,215.634552 
            C1397.067993,215.634735 1392.789917,215.634567 1388.407959,215.634567 
            C1388.212524,216.851562 1388.023804,217.479935 1388.023193,218.108505 
            C1388.003540,238.435425 1388.079224,258.762939 1387.927612,279.088776 
            C1387.899658,282.820587 1389.776001,283.010773 1392.598633,282.997559 
            C1407.260498,282.928864 1421.926636,283.160522 1436.582397,282.855469 
            C1441.395264,282.755341 1442.735107,284.128632 1442.712891,288.963593 
            C1442.524780,329.949921 1442.494629,370.937866 1442.657959,411.924408 
            C1442.727905,429.464539 1444.907104,446.775940 1450.776855,463.425323 
            C1457.424194,482.280670 1468.653320,497.373444 1486.721924,506.874481 
            C1501.493164,514.641663 1517.351929,517.319946 1533.809570,518.043884 
            C1560.846680,519.233093 1585.954712,513.563965 1608.655029,498.364014 
            C1611.383667,496.536835 1612.182129,495.215363 1610.283936,492.044708 
            C1602.005249,478.215607 1594.046997,464.194977 1585.936279,450.264893 
            C1583.284790,445.710968 1580.524048,441.220795 1577.920410,436.880157 
            C1577.044312,437.023529 1576.667114,436.989441 1576.404907,437.146698 
            C1575.695923,437.571869 1575.005493,438.040833 1574.360718,438.558380 
            C1565.415283,445.738831 1555.192261,448.158844 1543.951782,446.657288 
            C1535.404907,445.515594 1528.691895,441.485443 1524.101318,434.022156 
            C1518.998169,425.725800 1518.050171,416.511505 1518.038086,407.122406 
            C1517.986694,367.468201 1518.077515,327.813690 1517.925171,288.160004 
            C1517.908813,283.905396 1519.280884,282.852814 1523.339966,282.883911 
            C1545.665039,283.055084 1567.992676,282.878693 1590.317871,283.044312 
            C1594.343140,283.074158 1595.790649,282.100311 1595.739014,277.792328 
            C1595.509033,258.634399 1595.644775,239.472183 1595.627197,220.311523 
            C1595.625854,218.879166 1595.456909,217.446976 1595.341675,215.634476 
            C1582.784180,215.634476 1570.642212,215.634476 1557.500122,215.634537 
          M836.298279,236.023972 
            C834.305847,230.574982 832.111023,225.188660 830.396667,219.653534 
            C829.366882,216.328293 827.568298,215.522598 824.253906,215.542664 
            C800.594421,215.685852 776.933594,215.612350 753.273193,215.634018 
            C751.852173,215.635315 750.431396,215.862503 748.417114,216.035553 
            C754.508057,231.797379 760.391602,246.944458 766.217773,262.113495 
            C783.234314,306.417511 800.256531,350.719360 817.222046,395.042908 
            C831.696411,432.858093 846.130249,470.688934 860.464661,508.557281 
            C861.666870,511.733337 863.333252,512.789978 866.691956,512.769043 
            C889.018494,512.630005 911.346863,512.626282 933.673218,512.774780 
            C936.921509,512.796387 938.399963,511.609802 939.460022,508.723969 
            C942.549561,500.313477 945.820496,491.968475 949.101624,483.629761 
            C964.539124,444.397034 980.021118,405.181793 995.453674,365.947052 
            C1009.245728,330.882843 1023.000122,295.803833 1036.758179,260.726257 
            C1042.555298,245.946167 1048.319336,231.153122 1054.252197,215.972717 
            C1053.009277,215.818130 1052.225586,215.635986 1051.441895,215.635468 
            C1027.281616,215.619232 1003.120667,215.707703 978.961731,215.527420 
            C975.268738,215.499878 974.587891,217.741928 973.670532,220.212692 
            C970.032654,230.010483 966.408691,239.813492 962.806152,249.624329 
            C945.302368,297.292419 927.813660,344.966034 910.302002,392.631226 
            C907.694641,399.728394 904.993347,406.791107 901.889526,415.057495 
            C900.837280,412.366486 900.291199,411.046112 899.801208,409.705261 
            C891.658936,387.427826 883.514221,365.151276 875.388977,342.867645 
            C862.485352,307.479279 849.595886,272.085724 836.298279,236.023972 
          M1661.976562,327.500000 
            C1661.976562,389.082550 1661.976562,450.665100 1661.976562,512.697937 
            C1664.387329,512.697937 1666.018799,512.697937 1667.650269,512.697937 
            C1688.814575,512.697876 1709.980713,512.545654 1731.141602,512.812195 
            C1736.011841,512.873535 1737.218384,511.424561 1737.201782,506.676147 
            C1737.033447,458.682190 1737.057129,410.687317 1737.143677,362.692902 
            C1737.156860,355.378387 1737.488037,348.040009 1738.144409,340.755249 
            C1741.131226,307.603241 1763.193970,287.291901 1796.498413,286.545715 
            C1812.013062,286.198090 1826.970093,288.021942 1840.670898,296.520660 
            C1841.197998,295.516266 1841.554443,294.986053 1841.770630,294.403687 
            C1849.043457,274.812866 1856.465942,255.275421 1863.513184,235.603638 
            C1869.140747,219.894836 1868.899048,219.954529 1852.444702,215.256241 
            C1836.062622,210.578644 1819.490845,209.005341 1802.581177,211.241943 
            C1779.256470,214.327103 1759.775146,224.177460 1745.948975,243.738831 
            C1742.840942,248.136124 1740.278198,252.918716 1737.464355,257.523926 
            C1737.152832,257.492279 1736.841309,257.460632 1736.529785,257.428986 
            C1736.529785,243.622787 1736.529785,229.816589 1736.529785,215.878082 
            C1711.341675,215.878082 1686.905396,215.878082 1661.976562,215.878082 
            C1661.976562,252.924057 1661.976562,289.712036 1661.976562,327.500000 
          M3133.282227,576.272888 
            C3127.152344,574.129700 3121.157227,573.919556 3114.792725,575.973511 
            C3102.462402,579.952881 3094.939697,590.348206 3095.292969,603.977722 
            C3095.617920,616.514343 3104.602539,627.801025 3116.390381,630.480591 
            C3130.925537,633.784790 3145.924072,625.886597 3150.242676,612.654053 
            C3155.249756,597.311768 3148.736572,582.749146 3133.282227,576.272888 
          z"
      />
      <path
        fill="#ED3131"
        opacity="1.000000"
        stroke="none"
        d="
          M2623.907959,215.481171 
            C2624.844482,214.470352 2625.600342,213.140213 2626.743164,212.494507 
            C2685.650146,179.211594 2744.595703,145.997589 2803.523193,112.751175 
            C2830.163330,97.721024 2856.806152,82.694374 2883.355957,67.506081 
            C2886.516357,65.698174 2888.825684,65.727486 2891.979492,67.518883 
            C2939.822510,94.692909 2987.729492,121.754173 3035.645996,148.798248 
            C3072.851562,169.796753 3110.092041,190.733337 3147.312256,211.706314 
            C3148.573242,212.416946 3149.779297,213.224915 3152.094482,214.658340 
            C3063.792236,264.529877 2976.328369,313.927826 2888.432129,363.599457 
            C2887.514648,363.887543 2887.029541,363.901917 2886.376465,363.580719 
            C2863.376709,350.294464 2840.567871,337.303223 2817.708496,324.401184 
            C2769.661377,297.283020 2721.599365,270.191193 2673.518555,243.132599 
            C2657.019775,233.847580 2640.447021,224.694504 2623.907959,215.481171 
          z"
      />
      <path
        fill="#28BDBE"
        opacity="1.000000"
        stroke="none"
        d="
          M2886.544678,363.916321 
            C2887.029541,363.901917 2887.514648,363.887543 2888.236816,363.911438 
            C2976.042725,413.382812 3063.611084,462.815918 3152.266357,512.862549 
            C3141.876221,518.755554 3132.690430,523.981445 3123.489990,529.181396 
            C3077.578857,555.128601 3031.673340,581.085999 2985.746826,607.005859 
            C2954.159668,624.833130 2922.562988,642.644409 2890.873291,660.287781 
            C2889.246338,661.193604 2886.248291,661.254944 2884.647705,660.356812 
            C2820.222656,624.210205 2755.879883,587.917053 2691.539795,551.619019 
            C2669.948975,539.438293 2648.387207,527.206116 2626.841064,514.946594 
            C2625.620117,514.251770 2624.662598,513.094421 2624.133789,511.762146 
            C2625.598633,510.998688 2626.563965,510.717834 2627.417969,510.238708 
            C2648.866211,498.206726 2670.317871,486.181671 2691.737305,474.098694 
            C2730.086182,452.465515 2768.421875,430.809174 2806.747559,409.135437 
            C2833.359863,394.085815 2859.946533,378.990967 2886.544678,363.916321 
          z"
      />
      <path
        fill="#051862"
        opacity="1.000000"
        stroke="none"
        d="
          M1234.000000,390.652863 
            C1200.199463,390.652802 1166.898804,390.652802 1133.555786,390.652802 
            C1135.581177,409.558197 1152.932007,435.850281 1180.161133,446.293182 
            C1214.638062,459.515686 1265.115601,456.507324 1291.492676,413.741089 
            C1311.265015,425.259460 1331.047974,436.777771 1350.813965,448.325256 
            C1351.502075,448.727203 1352.020264,449.420197 1353.369751,450.679352 
            C1348.164795,456.944885 1343.270142,463.376709 1337.821533,469.299164 
            C1317.978760,490.867859 1293.957520,505.500122 1265.456787,512.881958 
            C1240.597534,519.320618 1215.374756,520.837830 1190.182739,517.111938 
            C1139.377686,509.598022 1100.081055,484.461975 1075.960449,438.177460 
            C1066.901611,420.794830 1062.183350,402.024170 1060.045288,382.414124 
            C1058.288696,366.303314 1058.805298,350.379669 1061.927734,334.712921 
            C1070.802734,290.183929 1094.292480,255.268005 1133.408569,231.816742 
            C1167.258667,211.522537 1204.076660,205.567307 1242.941284,212.016113 
            C1282.575806,218.592682 1315.197510,237.062454 1339.237915,269.591125 
            C1354.869873,290.742462 1364.364746,314.531799 1366.594238,340.787689 
            C1367.887329,356.015656 1367.797607,371.361450 1368.299072,386.655243 
            C1368.336426,387.791321 1368.122803,388.935608 1367.976807,390.652924 
            C1323.390503,390.652924 1278.945190,390.652924 1234.000000,390.652863 
          M1220.500000,331.239960 
            C1244.341797,331.239960 1268.183716,331.239960 1292.641602,331.239960 
            C1288.277344,316.259979 1281.776733,303.969543 1271.036987,294.218689 
            C1253.718994,278.494995 1232.839355,273.351868 1210.113647,274.481934 
            C1182.006958,275.879608 1159.867554,288.307343 1144.277100,311.780273 
            C1140.495361,317.474091 1137.875366,323.939392 1134.106689,331.240143 
            C1163.641235,331.240143 1191.570557,331.240143 1220.500000,331.239960 
          z"
      />
      <path
        fill="#041861"
        opacity="1.000000"
        stroke="none"
        d="
          M750.112976,385.177856 
            C741.253723,441.238739 711.341919,481.230225 660.389771,504.949432 
            C634.400330,517.048035 606.737183,520.801819 578.134827,517.928040 
            C532.884033,513.381409 496.182251,493.349823 468.377075,457.425964 
            C454.777954,439.856110 446.006073,419.958099 441.157532,398.177277 
            C436.561371,377.530151 436.076965,356.779510 439.857330,336.213959 
            C446.886475,297.974884 465.613342,266.294220 496.539642,242.392288 
            C527.826843,218.211395 563.707520,207.756195 602.905762,209.863708 
            C667.208801,213.320999 722.891357,252.764999 743.999512,316.219635 
            C751.416687,338.516754 752.775208,361.478119 750.112976,385.177856 
          M590.564880,446.478333 
            C603.594116,447.200745 616.135864,444.934845 627.885986,439.371674 
            C672.510437,418.244080 689.199524,364.962524 664.871460,321.810333 
            C643.378418,283.686768 594.640442,269.665497 556.312744,290.579437 
            C521.421692,309.618134 505.142853,351.514130 517.629333,390.021454 
            C528.363220,423.124054 557.267456,444.354797 590.564880,446.478333 
          z"
      />
      <path
        fill="#041861"
        opacity="1.000000"
        stroke="none"
        d="
          M1970.795166,322.000000 
            C1971.059570,347.815002 1970.194336,373.208405 1971.943115,398.420441 
            C1973.362671,418.886841 1982.369141,436.531830 2002.546265,445.269257 
            C2032.546997,458.260590 2073.456299,450.795959 2087.660156,411.458771 
            C2091.381592,401.151825 2092.851074,390.561401 2092.838623,379.647156 
            C2092.778809,327.162354 2092.812012,274.677490 2092.812012,222.192627 
            C2092.812012,220.239075 2092.812012,218.285507 2092.812012,215.794312 
            C2118.689697,215.794312 2144.065674,215.794312 2170.038330,215.794312 
            C2170.038330,217.662735 2170.038330,219.440338 2170.038330,221.217941 
            C2170.038330,316.190521 2170.007080,411.163147 2170.131836,506.135590 
            C2170.137939,510.780396 2169.100342,512.384644 2164.141357,512.354126 
            C2142.821533,512.222595 2121.498779,512.542664 2100.177246,512.695007 
            C2098.368408,512.707947 2096.559814,512.696777 2094.125000,512.696777 
            C2094.125000,500.985962 2094.125000,489.621582 2094.125000,477.047516 
            C2092.418213,478.597687 2091.555176,479.208740 2090.905762,479.996155 
            C2066.100586,510.079071 2033.844727,521.429871 1995.628418,518.275024 
            C1978.677490,516.875610 1962.478760,512.980896 1947.574585,504.730316 
            C1922.138916,490.649719 1906.968262,468.555908 1899.045044,441.072205 
            C1894.825806,426.436279 1892.894043,411.405365 1892.856689,396.223328 
            C1892.713623,338.073822 1892.798828,279.923706 1892.798828,221.773834 
            C1892.798828,219.964081 1892.798828,218.154343 1892.798828,215.991180 
            C1918.788574,215.991180 1944.486206,215.991180 1970.795288,215.991180 
            C1970.795288,251.284103 1970.795288,286.392059 1970.795166,322.000000 
          z"
      />
      <path
        fill="#051862"
        opacity="1.000000"
        stroke="none"
        d="
          M2223.491211,456.517761 
            C2221.338379,452.749725 2219.385986,449.285797 2217.089355,445.210449 
            C2222.336914,443.014862 2227.267334,440.824188 2232.290527,438.873322 
            C2250.392822,431.843353 2268.575928,425.016998 2286.602783,417.799683 
            C2289.793945,416.522003 2290.951172,417.280670 2292.453125,419.876190 
            C2308.836670,448.189697 2334.322754,458.080811 2365.744141,455.996460 
            C2375.741943,455.333282 2385.479492,453.310303 2393.180420,446.806793 
            C2397.687012,443.000946 2401.623535,437.760223 2404.006592,432.365479 
            C2408.347900,422.536835 2404.675537,413.124603 2395.562500,407.407654 
            C2384.945801,400.747589 2372.894775,398.157562 2360.904541,395.416016 
            C2340.831787,390.826324 2320.647217,386.661804 2300.735840,381.453613 
            C2286.259766,377.667206 2272.583740,371.633850 2260.297607,362.734528 
            C2236.643066,345.600861 2228.001953,321.832336 2230.952881,293.786163 
            C2234.456055,260.489685 2254.541992,238.691147 2283.052490,223.724960 
            C2307.964844,210.647675 2334.898193,207.846664 2362.538330,208.936447 
            C2386.620361,209.885971 2409.636230,214.818375 2430.946777,226.464493 
            C2450.162109,236.965454 2465.399902,251.815231 2477.917236,269.613617 
            C2478.359131,270.242157 2478.645996,270.979797 2479.254883,272.143921 
            C2470.712158,275.659821 2462.492188,279.056244 2454.262207,282.427002 
            C2440.752197,287.960114 2427.229736,293.462097 2413.727295,299.013672 
            C2411.412354,299.965515 2409.781250,299.733063 2408.295898,297.401062 
            C2390.879150,270.058716 2357.408203,263.789856 2329.591797,272.052521 
            C2323.706787,273.800568 2317.512451,277.641266 2313.604980,282.311707 
            C2302.863037,295.151337 2307.506592,310.453461 2324.172363,316.241089 
            C2338.706299,321.288391 2353.786133,324.899811 2368.797607,328.404297 
            C2391.102783,333.611542 2413.703125,337.701935 2434.579834,347.700500 
            C2454.374756,357.180878 2470.719238,370.292694 2478.473389,391.668121 
            C2485.350586,410.627014 2485.457275,429.908997 2478.413086,448.799835 
            C2466.860107,479.780823 2443.788574,498.743286 2413.320068,509.767395 
            C2389.698486,518.314087 2365.268066,520.210388 2340.549805,518.205017 
            C2327.185547,517.120789 2313.719727,515.272339 2300.724609,512.053772 
            C2267.891113,503.921997 2241.812744,485.770813 2223.491211,456.517761 
          z"
      />
      <path
        fill="#041862"
        opacity="1.000000"
        stroke="none"
        d="
          M257.201843,518.719788 
            C194.040054,513.864136 147.984375,484.273224 121.745232,426.519318 
            C109.149239,398.794800 106.153465,369.380188 110.978615,339.177551 
            C117.351822,299.284882 136.201401,266.758820 167.962326,241.843307 
            C185.331802,228.217468 204.992004,219.336411 226.477768,214.159561 
            C250.372284,208.402359 274.396790,207.859207 298.284210,212.856583 
            C347.177338,223.085251 383.400574,250.278992 405.558838,295.450378 
            C409.634216,303.758301 409.520325,303.832275 400.936127,307.309906 
            C382.020538,314.972870 363.100891,322.625977 344.172791,330.257935 
            C342.806458,330.808807 341.358002,331.156097 339.565155,331.717896 
            C337.953613,328.517548 336.469421,325.402832 334.841919,322.364868 
            C322.844574,299.970612 304.523926,286.660004 279.303864,282.134308 
            C238.306427,274.777435 199.966858,301.066284 188.122711,339.240387 
            C175.099594,381.214478 197.650482,427.029602 239.002640,441.694397 
            C278.520844,455.708740 319.194489,438.775177 337.246918,400.792511 
            C340.198608,394.582092 340.116028,394.779724 346.294983,397.361206 
            C365.741760,405.485901 385.243286,413.480225 404.752106,421.455292 
            C411.077057,424.040955 411.296387,424.034576 408.257141,429.965668 
            C388.918884,467.704681 360.709290,495.591705 320.008636,509.858154 
            C299.757019,516.956787 278.948944,519.275452 257.201843,518.719788 
          z"
      />
      <path
        fill="#041861"
        opacity="1.000000"
        stroke="none"
        d="
          M1558.000244,215.634506 
            C1570.642212,215.634476 1582.784180,215.634476 1595.341675,215.634476 
            C1595.456909,217.446976 1595.625854,218.879166 1595.627197,220.311523 
            C1595.644775,239.472183 1595.509033,258.634399 1595.739014,277.792328 
            C1595.790649,282.100311 1594.343140,283.074158 1590.317871,283.044312 
            C1567.992676,282.878693 1545.665039,283.055084 1523.339966,282.883911 
            C1519.280884,282.852814 1517.908813,283.905396 1517.925171,288.160004 
            C1518.077515,327.813690 1517.986694,367.468201 1518.038086,407.122406 
            C1518.050171,416.511505 1518.998169,425.725800 1524.101318,434.022156 
            C1528.691895,441.485443 1535.404907,445.515594 1543.951782,446.657288 
            C1555.192261,448.158844 1565.415283,445.738831 1574.360718,438.558380 
            C1575.005493,438.040833 1575.695923,437.571869 1576.404907,437.146698 
            C1576.667114,436.989441 1577.044312,437.023529 1577.920410,436.880157 
            C1580.524048,441.220795 1583.284790,445.710968 1585.936279,450.264893 
            C1594.046997,464.194977 1602.005249,478.215607 1610.283936,492.044708 
            C1612.182129,495.215363 1611.383667,496.536835 1608.655029,498.364014 
            C1585.954712,513.563965 1560.846680,519.233093 1533.809570,518.043884 
            C1517.351929,517.319946 1501.493164,514.641663 1486.721924,506.874481 
            C1468.653320,497.373444 1457.424194,482.280670 1450.776855,463.425323 
            C1444.907104,446.775940 1442.727905,429.464539 1442.657959,411.924408 
            C1442.494629,370.937866 1442.524780,329.949921 1442.712891,288.963593 
            C1442.735107,284.128632 1441.395264,282.755341 1436.582397,282.855469 
            C1421.926636,283.160522 1407.260498,282.928864 1392.598633,282.997559 
            C1389.776001,283.010773 1387.899658,282.820587 1387.927612,279.088776 
            C1388.079224,258.762939 1388.003540,238.435425 1388.023193,218.108505 
            C1388.023804,217.479935 1388.212524,216.851562 1388.407959,215.634567 
            C1392.789917,215.634567 1397.067993,215.634735 1401.345947,215.634552 
            C1413.508789,215.634033 1425.673828,215.505676 1437.833130,215.709869 
            C1441.523315,215.771835 1442.720581,214.715332 1442.683472,210.936646 
            C1442.506470,192.944016 1442.709106,174.947617 1442.523804,156.955154 
            C1442.483643,153.047974 1443.560791,150.871368 1447.142944,148.807373 
            C1468.882446,136.281082 1490.412231,123.391167 1512.029053,110.651405 
            C1513.690918,109.672035 1515.482666,108.913376 1518.044067,107.639259 
            C1518.044067,143.997559 1518.044067,179.521729 1518.044067,215.634537 
            C1531.605469,215.634537 1544.552734,215.634537 1558.000244,215.634506 
          z"
      />
      <path
        fill="#041861"
        opacity="1.000000"
        stroke="none"
        d="
          M836.499390,236.359192 
            C849.595886,272.085724 862.485352,307.479279 875.388977,342.867645 
            C883.514221,365.151276 891.658936,387.427826 899.801208,409.705261 
            C900.291199,411.046112 900.837280,412.366486 901.889526,415.057495 
            C904.993347,406.791107 907.694641,399.728394 910.302002,392.631226 
            C927.813660,344.966034 945.302368,297.292419 962.806152,249.624329 
            C966.408691,239.813492 970.032654,230.010483 973.670532,220.212692 
            C974.587891,217.741928 975.268738,215.499878 978.961731,215.527420 
            C1003.120667,215.707703 1027.281616,215.619232 1051.441895,215.635468 
            C1052.225586,215.635986 1053.009277,215.818130 1054.252197,215.972717 
            C1048.319336,231.153122 1042.555298,245.946167 1036.758179,260.726257 
            C1023.000122,295.803833 1009.245728,330.882843 995.453674,365.947052 
            C980.021118,405.181793 964.539124,444.397034 949.101624,483.629761 
            C945.820496,491.968475 942.549561,500.313477 939.460022,508.723969 
            C938.399963,511.609802 936.921509,512.796387 933.673218,512.774780 
            C911.346863,512.626282 889.018494,512.630005 866.691956,512.769043 
            C863.333252,512.789978 861.666870,511.733337 860.464661,508.557281 
            C846.130249,470.688934 831.696411,432.858093 817.222046,395.042908 
            C800.256531,350.719360 783.234314,306.417511 766.217773,262.113495 
            C760.391602,246.944458 754.508057,231.797379 748.417114,216.035553 
            C750.431396,215.862503 751.852173,215.635315 753.273193,215.634018 
            C776.933594,215.612350 800.594421,215.685852 824.253906,215.542664 
            C827.568298,215.522598 829.366882,216.328293 830.396667,219.653534 
            C832.111023,225.188660 834.305847,230.574982 836.499390,236.359192 
          z"
      />
      <path
        fill="#031760"
        opacity="1.000000"
        stroke="none"
        d="
          M2886.376465,363.580750 
            C2859.946533,378.990967 2833.359863,394.085815 2806.747559,409.135437 
            C2768.421875,430.809174 2730.086182,452.465515 2691.737305,474.098694 
            C2670.317871,486.181671 2648.866211,498.206726 2627.417969,510.238708 
            C2626.563965,510.717834 2625.598633,510.998688 2624.302734,511.439575 
            C2623.722900,510.056671 2623.353516,508.606201 2623.353271,507.155670 
            C2623.332520,411.048370 2623.340820,314.941132 2623.351562,218.833878 
            C2623.351562,218.002472 2623.416260,217.171066 2623.679199,215.910400 
            C2640.447021,224.694504 2657.019775,233.847580 2673.518555,243.132599 
            C2721.599365,270.191193 2769.661377,297.283020 2817.708496,324.401184 
            C2840.567871,337.303223 2863.376709,350.294464 2886.376465,363.580750 
          z"
      />
      <path
        fill="#041861"
        opacity="1.000000"
        stroke="none"
        d="
          M1661.976562,327.000000 
            C1661.976562,289.712036 1661.976562,252.924057 1661.976562,215.878082 
            C1686.905396,215.878082 1711.341675,215.878082 1736.529785,215.878082 
            C1736.529785,229.816589 1736.529785,243.622787 1736.529785,257.428986 
            C1736.841309,257.460632 1737.152832,257.492279 1737.464355,257.523926 
            C1740.278198,252.918716 1742.840942,248.136124 1745.948975,243.738831 
            C1759.775146,224.177460 1779.256470,214.327103 1802.581177,211.241943 
            C1819.490845,209.005341 1836.062622,210.578644 1852.444702,215.256241 
            C1868.899048,219.954529 1869.140747,219.894836 1863.513184,235.603638 
            C1856.465942,255.275421 1849.043457,274.812866 1841.770630,294.403687 
            C1841.554443,294.986053 1841.197998,295.516266 1840.670898,296.520660 
            C1826.970093,288.021942 1812.013062,286.198090 1796.498413,286.545715 
            C1763.193970,287.291901 1741.131226,307.603241 1738.144409,340.755249 
            C1737.488037,348.040009 1737.156860,355.378387 1737.143677,362.692902 
            C1737.057129,410.687317 1737.033447,458.682190 1737.201782,506.676147 
            C1737.218384,511.424561 1736.011841,512.873535 1731.141602,512.812195 
            C1709.980713,512.545654 1688.814575,512.697876 1667.650269,512.697937 
            C1666.018799,512.697937 1664.387329,512.697937 1661.976562,512.697937 
            C1661.976562,450.665100 1661.976562,389.082550 1661.976562,327.000000 
          z"
      />
      <path
        fill="#2F3F7C"
        opacity="1.000000"
        stroke="none"
        d="
          M3133.663330,576.354187 
            C3148.736572,582.749146 3155.249756,597.311768 3150.242676,612.654053 
            C3145.924072,625.886597 3130.925537,633.784790 3116.390381,630.480591 
            C3104.602539,627.801025 3095.617920,616.514343 3095.292969,603.977722 
            C3094.939697,590.348206 3102.462402,579.952881 3114.792725,575.973511 
            C3121.157227,573.919556 3127.152344,574.129700 3133.663330,576.354187 
          M3138.525635,583.860779 
            C3137.836182,583.396545 3137.159424,582.912231 3136.455566,582.470947 
            C3127.952881,577.140137 3116.250000,577.756165 3108.369873,583.942688 
            C3100.958740,589.761169 3097.426025,601.533203 3100.527588,610.075562 
            C3104.491211,620.992798 3113.004150,627.302063 3123.707764,627.256165 
            C3133.008301,627.216309 3142.960693,620.905090 3145.813477,612.110291 
            C3149.179932,601.730286 3147.732666,592.025452 3138.525635,583.860779 
          z"
      />
      <path
        fill="none"
        opacity="1.000000"
        stroke="none"
        d="
          M1220.000000,331.240051 
            C1191.570557,331.240143 1163.641235,331.240143 1134.106689,331.240143 
            C1137.875366,323.939392 1140.495361,317.474091 1144.277100,311.780273 
            C1159.867554,288.307343 1182.006958,275.879608 1210.113647,274.481934 
            C1232.839355,273.351868 1253.718994,278.494995 1271.036987,294.218689 
            C1281.776733,303.969543 1288.277344,316.259979 1292.641602,331.239960 
            C1268.183716,331.239960 1244.341797,331.239960 1220.000000,331.240051 
          z"
      />
      <path
        fill="none"
        opacity="1.000000"
        stroke="none"
        d="
          M590.078125,446.464417 
            C557.267456,444.354797 528.363220,423.124054 517.629333,390.021454 
            C505.142853,351.514130 521.421692,309.618134 556.312744,290.579437 
            C594.640442,269.665497 643.378418,283.686768 664.871460,321.810333 
            C689.199524,364.962524 672.510437,418.244080 627.885986,439.371674 
            C616.135864,444.934845 603.594116,447.200745 590.078125,446.464417 
          z"
      />
      <path
        fill="none"
        opacity="1.000000"
        stroke="none"
        d="
          M3138.818848,584.078003 
            C3147.732666,592.025452 3149.179932,601.730286 3145.813477,612.110291 
            C3142.960693,620.905090 3133.008301,627.216309 3123.707764,627.256165 
            C3113.004150,627.302063 3104.491211,620.992798 3100.527588,610.075562 
            C3097.426025,601.533203 3100.958740,589.761169 3108.369873,583.942688 
            C3116.250000,577.756165 3127.952881,577.140137 3136.455566,582.470947 
            C3137.159424,582.912231 3137.836182,583.396545 3138.818848,584.078003 
          M3132.451416,608.023682 
            C3129.551514,605.692505 3132.191895,604.985168 3133.633301,603.842224 
            C3137.026611,601.151306 3137.743408,597.492371 3136.922363,593.511780 
            C3136.141113,589.726990 3133.659912,587.193665 3129.837158,586.794739 
            C3124.747559,586.263611 3119.600830,586.131287 3114.481689,586.180603 
            C3113.633301,586.188843 3112.093018,587.984070 3112.073486,588.977539 
            C3111.888184,598.277954 3111.889404,607.585205 3112.084473,616.885254 
            C3112.103516,617.791138 3113.945557,619.499634 3114.659668,619.362976 
            C3115.884766,619.128540 3117.513672,617.913452 3117.842285,616.781616 
            C3118.376953,614.940857 3117.780273,612.802063 3118.076660,610.852173 
            C3118.321289,609.240906 3119.045410,606.478760 3119.770508,606.407776 
            C3121.516113,606.236816 3123.955078,606.821594 3125.086426,608.048889 
            C3127.292480,610.442627 3128.961914,613.393188 3130.544922,616.282349 
            C3132.419678,619.704712 3134.879150,620.328491 3138.835693,618.596558 
            C3136.739746,615.075073 3134.815918,611.842896 3132.451416,608.023682 
          z"
      />
      <path
        fill="#1F3172"
        opacity="1.000000"
        stroke="none"
        d="
          M3132.671875,608.317139 
            C3134.815918,611.842896 3136.739746,615.075073 3138.835693,618.596558 
            C3134.879150,620.328491 3132.419678,619.704712 3130.544922,616.282349 
            C3128.961914,613.393188 3127.292480,610.442627 3125.086426,608.048889 
            C3123.955078,606.821594 3121.516113,606.236816 3119.770508,606.407776 
            C3119.045410,606.478760 3118.321289,609.240906 3118.076660,610.852173 
            C3117.780273,612.802063 3118.376953,614.940857 3117.842285,616.781616 
            C3117.513672,617.913452 3115.884766,619.128540 3114.659668,619.362976 
            C3113.945557,619.499634 3112.103516,617.791138 3112.084473,616.885254 
            C3111.889404,607.585205 3111.888184,598.277954 3112.073486,588.977539 
            C3112.093018,587.984070 3113.633301,586.188843 3114.481689,586.180603 
            C3119.600830,586.131287 3124.747559,586.263611 3129.837158,586.794739 
            C3133.659912,587.193665 3136.141113,589.726990 3136.922363,593.511780 
            C3137.743408,597.492371 3137.026611,601.151306 3133.633301,603.842224 
            C3132.191895,604.985168 3129.551514,605.692505 3132.671875,608.317139 
          M3117.982422,599.069275 
            C3120.385498,602.533203 3128.983643,602.483459 3130.443604,598.832947 
            C3131.535156,596.104675 3131.622314,593.110657 3128.247803,591.636108 
            C3121.765137,588.803162 3117.962891,591.280151 3117.982422,599.069275 
          z"
      />
      <path
        fill="none"
        opacity="1.000000"
        stroke="none"
        d="
          M3117.972412,598.632385 
            C3117.962891,591.280151 3121.765137,588.803162 3128.247803,591.636108 
            C3131.622314,593.110657 3131.535156,596.104675 3130.443604,598.832947 
            C3128.983643,602.483459 3120.385498,602.533203 3117.972412,598.632385 
          z"
      />
    </svg>
  );
}
